/**
 * Espanhol.
 *
 * Chave ausente cai no inglês — ver `i18n/index.js`.
 *
 * Espanhol neutro, sem regionalismo: o público provável é a América Latina
 * inteira, e escolher entre "ordenador" e "computadora" ou entre "vosotros" e
 * "ustedes" excluiria metade dele. Onde há dúvida, a forma usada na América
 * Latina, que é o mercado mais próximo.
 */
const es = {
  comum: {
    salvar: 'Guardar cambios',
    salvando: 'Guardando…',
    cancelar: 'Cancelar',
    fechar: 'Cerrar',
    pularConteudo: 'Saltar al contenido',
    carregando: 'Cargando…',
    soGestor: 'Solo un gestor de la empresa puede cambiar esto.',
    voltar: 'Volver',
    buscar: 'Buscar',
    todos: 'Todos',
    ordenarPor: 'Ordenar por',
    ordemPadrao: 'Orden predeterminado',
    crescente: 'ascendente',
    decrescente: 'descendente'
  },

  menu: {
    visaoGeral: 'Visión general',
    painel: 'Panel',
    projetos: 'Proyectos',
    meusProjetos: 'Mis proyectos',
    criarProjeto: 'Crear proyecto',
    conta: 'Cuenta',
    perfil: 'Mi perfil',
    pagamentos: 'Pagos',
    planoEUso: 'Plan y uso',
    legal: 'Legal',
    privacidade: 'Política de Privacidad',
    termos: 'Términos del Servicio',
    sair: 'Cerrar sesión',
    creditosSufixo: '/{total} créditos de IA',
    faturamento: 'Facturación',
    configuracoes: 'Configuración',
    planos: 'Planes',
    execucoes: 'Ejecuciones',
    ajuda: 'Ayuda',
    documentacao: 'Documentación',
    creditos: '{restantes}/{total} créditos de IA'
  },

  conta: {
    titulo: 'Cuenta',
    plano: 'Plan {plano}',
    verPlanos: 'Ver todos los planes',

    perfil: 'Perfil',
    nome: 'Nombre',
    email: 'Correo electrónico',
    trocarFoto: 'Cambiar',
    enviandoFoto: 'Subiendo…',
    perfilSalvo: 'Perfil actualizado.',
    fotoSalva: 'Foto de perfil actualizada.',

    empresaTexto: 'Los datos de registro de la empresa. Solo un gestor puede cambiarlos.',
    freelancerTexto:
      'Tu cuenta es de una sola persona: el plan, los créditos de IA y los proyectos son solo tuyos. Para convertirla en empresa, completa los datos. El plan, los créditos y los proyectos siguen como están, y no se puede volver a freelancer.',
    soGestor: 'Solo un gestor puede cambiar los datos de la empresa.',
    converter: 'Convertir en empresa',
    confirmarConversao: '¿Convertir esta cuenta en empresa? No se puede volver a freelancer.',
    convertida: 'Tu cuenta ahora es una empresa.',
    empresaSalva: 'Datos de la empresa actualizados.',

    idioma: 'Idioma',
    idiomaAjuda: 'Se aplica a la interfaz y al análisis de IA. Los precios siguen en dólares.',
    idiomaSalvo: 'Idioma actualizado.',

    uso: 'Uso',
    projetos: 'Proyectos',
    paginasEVideos: 'Páginas y videos',
    detalhePaginas: '{sites} páginas de sitio · {youtube} videos de YouTube',
    melhorarPara: 'Cambiar a {plano}',
    falarConosco: 'Hablemos',

    creditos: 'Créditos de IA',
    restantesNoMes: 'restantes este mes',
    esteMes: '{n} de este mes',
    comprados: '{n} comprados',
    comprarChamada:
      '¿Necesitas más este mes? Los créditos comprados no vencen — quedan hasta que los uses.',
    comprarPacote: 'Comprar {n} créditos',
    abrindo: 'Abriendo…',
    pagamentoRecebido: 'Pago recibido. Tus créditos aparecerán en un momento.',
    reiniciaEm: 'Se renueva el {data}',
    tokensPorAnalise: '{n} tokens por análisis',

    conector: 'Conector para IA',
    conectorIntro:
      'Por defecto, la IA conectada solo lee tus datos. Aquí puedes permitir que también solicite rastreos.',
    conectorEscrita: 'Permitir que la IA conectada solicite rastreos',
    conectorNotaCota: 'Cada rastreo consume la cuota de páginas de tu plan, y eso no es reversible.',
    conectorNotaLimite:
      'Hay un tope diario de rastreos por esta vía, y uno a la vez por proyecto. Desde la pantalla de Silent Puma no existe ese límite.',
    conectorNotaEscopo:
      'Nada más cambia: la IA sigue sin poder crear proyectos, borrar ejecuciones, generar análisis ni alterar tu cuenta.',
    conectorReconectar:
      'Quita y añade el conector de nuevo en tu IA para que el cambio tenga efecto — guarda la lista de herramientas de cuando conectaste.',
    zonaDeRisco: 'Zona de riesgo',
    riscoBasic:
      'Eliminar la cuenta borra todos los proyectos, ejecuciones y análisis. No se puede deshacer.',
    riscoPago:
      'Cancelar mantiene el plan hasta el final del período ya pagado. Eliminar la cuenta borra todo de inmediato, sin vuelta atrás.',
    riscoAnalista: 'Eliminar tu cuenta solo te saca de la empresa: los proyectos y las ejecuciones quedan con el equipo.',
    confirmarSaida: '¿Eliminar tu cuenta y salir de la empresa? No se puede deshacer.',
    cancelarAssinatura: 'Cancelar suscripción',
    assinaturaEncerra: 'La suscripción termina al final del período actual.',
    apagarConta: 'Eliminar cuenta',
    confirmarCancelamento:
      'Tu suscripción sigue activa hasta el final del período ya pagado y luego pasa a Basic. ¿Continuar?',
    confirmarExclusao: '¿Eliminar tu cuenta y todo lo que contiene? Esto no se puede deshacer.',
    contaApagada: 'Tu cuenta fue eliminada de forma permanente.',

    business: 'Plan Business',
    businessChamada: 'Cuéntanos qué necesitas y preparamos una propuesta.',
    empresa: 'Empresa',
    mensagem: 'Mensaje',
    enviarMensagem: 'Enviar mensaje',
    enviando: 'Enviando…',
    mensagemEnviada: 'Mensaje enviado. Te respondemos pronto.'
  },

  equipe: {
    titulo: 'Equipo',
    texto: 'Quien entra al equipo usa los mismos proyectos, la misma cuota y los mismos créditos de la empresa.',
    textoAnalista: 'Solo un gestor invita personas y cancela invitaciones.',
    textoFreelancer: 'Los equipos son de empresas. Convierte la cuenta en empresa en la pestaña Empresa para invitar personas.',
    textoBasic: 'Invitar personas empieza en el plan Guru.',
    gestor: 'Gestor',
    analista: 'Analista',
    papel: 'Rol',
    pendente: 'Invitación pendiente, válida hasta el {data}',
    expirado: 'Invitación vencida. Invita de nuevo para enviar otro enlace.',
    cancelar: 'Cancelar invitación',
    confirmarCancelamento: '¿Cancelar la invitación para {email}? El enlace deja de funcionar.',
    cancelado: 'Invitación cancelada.',
    convidarTitulo: 'Invitar',
    convidarTexto:
      'La invitación va por correo y es válida por 7 días. El analista trabaja en los proyectos; el gestor también se ocupa del plan, los pagos, las integraciones y el equipo.',
    enviar: 'Enviar invitación',
    enviando: 'Enviando…',
    enviado: 'Invitación enviada. El enlace es válido por 7 días.',
    conviteTitulo: 'Invitación al equipo',
    chamada: 'Tu equipo ya está en Silent Puma.',
    aceitarTitulo: 'Entrar en {organizacao}',
    aceitarTexto: 'La invitación es para entrar como {papel}. Crea tu acceso.',
    aceitar: 'Aceptar y entrar',
    aceitando: 'Entrando…',
    voce: '(tú)',
    papelDe: 'Rol de {nome}',
    papelMudado: 'Rol cambiado.',
    remover: 'Quitar',
    confirmarRemocao: '¿Quitar a {nome} del equipo? Su cuenta se elimina; los proyectos y las ejecuciones quedan con la empresa.',
    removido: 'Persona quitada del equipo.'
  },
  painel: {
    ola: '¡Bienvenido de vuelta, {nome}!',
    chamada: 'Mejoremos tu SEO hoy.',
    projetos: 'Proyectos',
    paginasNoMes: 'Páginas este mes',
    creditos: 'Créditos de IA',
    ilimitado: 'ilimitado',
    execucoesRecentes: 'Ejecuciones recientes',
    verProjetos: 'Ver proyectos',
    semExecucoes: 'Aún no hay ejecuciones.',
    criarProjeto: 'Crear un proyecto',
    paraComecar: 'para empezar.',
    atalhoComecar: 'Primeros pasos',
    atalhoComecarTexto: 'Crea tu primer proyecto y ejecuta el primer análisis.',
    atalhoComecarCta: 'Crear proyecto',
    atalhoAnalise: 'Ejecutar análisis',
    atalhoAnaliseTexto: 'Inicia una ejecución en un proyecto que ya tienes.',
    atalhoAnaliseCta: 'Ver proyectos',
    atalhoPlano: 'Plan y uso',
    atalhoPlanoTexto: 'Páginas, créditos de IA y lo que tu plan todavía cubre.',
    atalhoPlanoCta: 'Ver uso'
  },

  execucao: {
    coluna: 'Ejecución',
    projeto: 'Proyecto',
    paginas: 'Páginas',
    videos: 'Videos',
    status: 'Estado',
    iniciada: 'Inicio',
    acoes: 'Acciones',
    limite: 'límite',
    concluida: 'Completada',
    emAndamento: 'En curso',
    naFila: 'En cola',
    falhou: 'Falló',
    cancelada: 'Cancelada',
    verAnalise: 'Ver análisis',
    otimizacoes: 'Optimizaciones de IA',
    relatorio: 'Informe',
    detalhes: 'Detalles',
    repetir: 'Repetir',
    repetindo: 'Iniciando…',
    repetirAjuda: 'Rastrea las mismas páginas otra vez, para comparar',
    mesmasPaginas: 'Mismas páginas de la ejecución #{n}',
    novaExecucao: '+ Nueva ejecución',
    buscar: 'Buscar ejecuciones...',
    filtrar: 'Filtrar por estado',
    total: { um: '{n} ejecución', outros: '{n} ejecuciones' },
    retencao: 'retención de {n} días',
    semExpiracao: 'sin expiración de datos',
    vazio: 'Este proyecto aún no tiene ejecuciones.',
    semFiltro: 'Ninguna ejecución coincide con el filtro.',
    primeira: 'Iniciar la primera ejecución',
    confirmarExclusao: '¿Seguro que quieres eliminar esta ejecución?',
    parar: 'Detener',
    confirmarParada: '¿Detener esta ejecución ahora? Las páginas ya recopiladas se conservan, pero no recibirá puntuación.',
    apagar: 'Eliminar ejecución {n}'
  },

  projeto: {
    titulo: 'Mis proyectos',
    total: { um: '{n} proyecto en total', outros: '{n} proyectos en total' },
    vagas: '{usados} de {limite} espacios en el plan {plano}',
    buscar: 'Buscar proyectos...',
    filtrar: 'Filtrar por tipo',
    site: 'Sitio web',
    youtube: 'YouTube',
    paginas: 'páginas',
    videos: 'videos',
    execucoes: 'ejecuciones',
    ultimaExecucao: 'última ejecución',
    verExecucoes: 'Ver ejecuciones',
    baixarCsv: 'Descargar CSV',
    painel: 'Panel',
    novo: 'Nuevo proyecto',
    primeiro: 'Crea tu primer proyecto',
    tipoDeProjeto: 'Sitio web o canal de YouTube.',
    vagasLivres: {
      um: '{n} espacio libre en el plan {plano}.',
      outros: '{n} espacios libres en el plan {plano}.'
    },
    criar: '+ Crear proyecto',
    confirmarExclusao: '¿Seguro que quieres eliminar este proyecto?',
    apagar: 'Eliminar {nome}',
    integracoesDe: 'Integraciones de {nome}',
    integracoesChamada: 'Conecta datos de Google para enriquecer los análisis de este proyecto.',
    soNoPro: 'Disponible en Pro',
    soNoProTexto:
      'Las integraciones con Google Analytics, Search Console y YouTube Analytics son parte de los planes Pro y Business.',
    verPlanos: 'Ver planes',
    hoje: 'hoy',
    ontem: 'ayer',
    diasAtras: 'hace {n}d',
    mesesAtras: 'hace {n}m',
    anosAtras: 'hace {n}a'
  },

  paginacao: { anterior: 'Anterior', proxima: 'Siguiente' },

  site: {
    idioma: 'Idioma',
    recursos: 'Funciones',
    precos: 'Precios',
    blog: 'Blog',
    contato: 'Contacto',
    abrirMenu: 'Abrir menú',
    entrar: 'Iniciar sesión',
    experimentar: '¡Probar!',
    produto: 'Producto',
    empresa: 'Empresa',
    legal: 'Legal',
    privacidade: 'Política de Privacidad',
    termos: 'Términos del Servicio',
    direitos: '© {ano} Silent Puma. Todos los derechos reservados.'
  },

  /* Title e description das páginas públicas — ver src/config/seo.js. */
  seo: {
    homeTitulo: 'Silent Puma — auditoría SEO para sitios y canales de YouTube',
    homeDescricao:
      'Rastrea tu sitio, ve qué está roto ordenado por impacto y recibe recomendaciones de IA. Auditoría SEO para sitios y YouTube, gratis hasta 3.000 páginas al mes.',
    blogTitulo: 'Blog: qué medimos y qué significan los números',
    blogDescricao:
      'Notas técnicas sobre auditoría SEO de quienes ejecutan crawlers a diario. Cada post trae el método, para que lo compruebes en lugar de creerlo.',
    planosTitulo: 'Planes y precios: empieza gratis',
    planosDescricao:
      'Compara los planes. Basic es gratis: 1 proyecto, 3.000 páginas al mes, sin tarjeta. Los de pago suman proyectos, páginas, retención y créditos de IA.',
    privacidadeTitulo: 'Política de Privacidad: qué recopilamos',
    privacidadeDescricao:
      'Qué recopila Silent Puma, qué recopila el crawler, cómo el análisis de IA y las integraciones con Google usan tus datos, cuánto se guardan y tus derechos.',
    termosTitulo: 'Términos de Servicio',
    termosDescricao:
      'Los términos de uso de Silent Puma: tu cuenta, qué puedes rastrear, planes, límites y créditos, pagos y cancelación, recomendaciones de IA y retención de datos.',
    entrarTitulo: 'Inicia sesión en tu panel SEO',
    entrarDescricao:
      'Inicia sesión en Silent Puma para ver tus proyectos, ejecuciones de rastreo, scores de SEO y recomendaciones de IA para tus sitios y canales de YouTube.',
    cadastroTitulo: 'Crea tu cuenta gratis',
    cadastroDescricao:
      'Crea una cuenta gratis en Silent Puma: 1 proyecto y 3.000 páginas al mes, exportación CSV desde el primer día y sin tarjeta. Cambia de plan cuando lo necesites.'
  },

  concluir: {
    titulo: 'Termina tu registro',
    texto: 'Stripe confirmó tu plan. Ahora define la contraseña con la que vas a entrar.',
    textoGoogle: 'Stripe confirmó tu plan. La cuenta queda vinculada a Google: entras con el botón de Google, sin contraseña.',
    conferindo: 'Comprobando la confirmación de Stripe…',
    regrasTitulo: 'La contraseña necesita:',
    atendida: 'cumplida',
    contaExiste: 'Esta cuenta ya fue creada.',
    formato: '¿Cómo vas a usar Silent Puma?',
    freelancer: 'Freelancer',
    empresa: 'Empresa',
    equipeNasConfiguracoes: 'Después del registro, invita a tu equipo en Configuración, desde el plan Guru.',
    nomeDaEmpresa: 'Nombre de la empresa',
    funcionarios: 'Número de empleados',
    tipoEmpresa: 'Tipo de empresa',
    selecione: 'Selecciona',
    ate10: 'Hasta 10',
    de11a50: '11 a 50',
    de51a200: '51 a 200',
    de201a1000: '201 a 1.000',
    maisDe1000: 'Más de 1.000',
    agencia: 'Agencia, que atiende clientes',
    padrao: 'Empresa, que cuida su propia marca',
    faltaFormato: 'Elige cómo vas a usar Silent Puma.',
    faltaEmpresa: 'Indica el nombre, el número de empleados y el tipo de la empresa.'
  },

  juridico: {
    nestaPagina: 'En esta página',
    emResumo: 'En resumen',
    traducao: 'Traducción del texto en inglés, que prevalece si las dos versiones difieren.',
    lerEmIngles: 'Read in English',
    leiaTambem: 'Lee también:',
    copiarSecao: 'Copiar enlace a esta sección'
  },

  /* Aviso de cookies — components/AvisoDeCookies.js. */
  cookies: {
    titulo: 'Cookies',
    texto: 'Si lo permites, usamos Google Analytics para saber qué páginas se visitan. Sin tu permiso, no se envía nada a Google.',
    saibaMais: 'Más información',
    aceitar: 'Aceptar',
    recusar: 'Rechazar'
  },

  naoEncontrada: {
    titulo: 'Página no encontrada',
    ajuda: 'La página que buscas no existe o fue movida.',
    paraPainel: 'Ir a mi panel',
    paraHome: 'Volver al inicio',
    meusProjetos: 'Mis proyectos'
  },

  acesso: {
    provaRetencao: 'Ningún dato de rastreo se borra antes de la retención de tu plan.',
    runFeita: 'completada',
    runRodando: 'en curso',
    runFalhou: 'falló',
    pontoBasico: '1 proyecto y 3.000 páginas al mes',
    pontoBasicoSub: 'Sin tarjeta de crédito, sin fecha de vencimiento.',
    pontoCsv: 'Exportación en CSV desde el primer día',
    pontoCsvSub: 'Los datos son tuyos, en todos los planes.',
    pontoRetencao: 'Retención de 7 días en Basic',
    pontoRetencaoSub: '30 días en Guru, 90 en Pro, ilimitado en Business.',
    pontoUpgrade: 'Cambia de plan sin perder el historial',
    pontoUpgradeSub: 'Las ejecuciones antiguas siguen disponibles.',

    email: 'Correo electrónico',
    senha: 'Contraseña',
    mostrar: 'Mostrar',
    esconder: 'Ocultar',
    ou: 'O',
    comGoogle: 'Continuar con Google',
    continuar: 'Continuar',

    chamadaLogin: 'Tus proyectos y ejecuciones están donde los dejaste.',
    entrar: 'Iniciar sesión',
    entrarTexto: 'Inicia sesión para ver tus proyectos y ejecuciones.',
    entrando: 'Entrando…',
    semConta: '¿Todavía no tienes cuenta?',
    criarConta: 'Crear cuenta',
    esqueceu: '¿Olvidaste tu contraseña?',

    chamadaCadastro: 'Empieza en el plan gratuito, sin tarjeta.',
    criarTitulo: 'Crea tu cuenta',
    criarTexto: '1 proyecto y 3.000 páginas al mes, gratis.',
    nomeCompleto: 'Nombre completo',
    senhaDepois: 'Elegirás la contraseña en el siguiente paso, después de confirmar el plan.',
    criando: 'Creando…',
    criarBotao: 'Crear cuenta',
    jaTemConta: '¿Ya tienes cuenta?',
    consentimentoA: 'Al crear una cuenta aceptas nuestros',
    consentimentoE: 'y nuestra',

    chamadaEsqueci: 'De vuelta, con un solo correo.',
    esqueciTitulo: '¿Olvidaste tu contraseña?',
    esqueciTexto: 'Escribe el correo de tu cuenta y te enviamos un enlace para restablecerla.',
    enviando: 'Enviando…',
    enviarLink: 'Enviar enlace',
    linkEnviado: 'Si este correo está registrado, el enlace para restablecerla ya va en camino.',
    lembrou: '¿La recordaste?',

    chamadaNovaSenha: 'Define una contraseña nueva y sigue donde lo dejaste.',
    novaSenhaTitulo: 'Contraseña nueva',
    minimoDeCaracteres: 'Al menos {n} caracteres.',
    novaSenha: 'Contraseña nueva',
    confirmarSenha: 'Confirmar contraseña',
    salvando: 'Guardando…',
    atualizarSenha: 'Actualizar contraseña',
    senhaAtualizada: 'Contraseña actualizada. Te llevamos al inicio de sesión…',
    voltarAoLogin: 'Volver al inicio de sesión',
    senhasDiferentes: 'Las contraseñas no coinciden.',
    senhaCurta: 'La contraseña necesita al menos {n} caracteres.',

    chamadaConcluir: 'Falta un paso — y luego tu primer rastreo.',
    concluirTitulo: 'Completa tu cuenta',
    concluirTexto: 'Pago confirmado. Define cómo vas a iniciar sesión.',
    seuNome: 'Tu nombre',
    seuEmail: 'Tu correo electrónico',
    escolhaSenha: 'Elige una contraseña',
    regrasAtendidas: '{n} de {total} reglas de contraseña cumplidas',
    aindaFalta: 'Todavía falta {itens}.',
    senhaPrecisa: 'La contraseña necesita {itens}.',
    contaGoogle: 'Cuenta vinculada a Google — entra con el botón de Google, sin contraseña.',
    concluindo: 'Finalizando…',
    concluirBotao: 'Completar registro',
    regraTamanho: 'al menos 8 caracteres',
    regraMaiuscula: 'una letra mayúscula',
    regraMinuscula: 'una letra minúscula',
    regraNumero: 'un número',
    regraEspecial: 'un carácter especial (!@#$%^&*)',

    autenticando: 'Autenticando…'
  },

  entrada: {
    titulo: 'Iniciar sesión en Silent Puma',
    texto: 'Tus proyectos y ejecuciones están donde los dejaste.',
    comGoogle: 'Continuar con Google',
    abrindoGoogle: 'Abriendo Google…',
    ouEmail: 'o con correo y contraseña',
    email: 'Correo electrónico',
    senha: 'Contraseña',
    esqueceu: '¿Olvidaste tu contraseña?',
    mostrar: 'Mostrar',
    esconder: 'Ocultar',
    botao: 'Iniciar sesión',
    entrando: 'Iniciando sesión…',
    faltaEmail: 'Escribe el correo de tu cuenta, con el formato nombre@empresa.com.',
    faltaSenha: 'Escribe la contraseña. Si creaste la cuenta con Google, usa el botón de Google de arriba.',
    erroDados: 'El correo o la contraseña no coinciden. Si creaste la cuenta con Google, usa el botón de Google de arriba.',
    erroMuitas: 'Demasiados intentos seguidos. Espera unos minutos y vuelve a intentarlo.',
    erroRede: 'No pudimos comunicarnos con el servidor. Revisa tu conexión y vuelve a intentarlo.',
    erroGoogle: 'El acceso con Google no se completó. Vuelve a intentarlo o entra con correo y contraseña.',
    semConta: '¿Todavía no tienes cuenta?',
    criarConta: 'Crear cuenta gratis',
    novoNoBlog: 'Nuevo en el blog: {titulo}',
    fotoAlt: 'Un puma caminando de noche hacia la cámara, fotografiado por una cámara trampa.',
    fotoCredito: 'Foto: National Park Service, dominio público'
  },

  recuperar: {
    titulo: 'Recuperar la contraseña',
    texto: 'Escribe el correo de tu cuenta y te enviamos un enlace para definir una contraseña nueva.',
    botao: 'Enviar el enlace',
    enviando: 'Enviando…',
    enviado: 'Si hay una cuenta con {email}, el enlace ya va en camino.',
    validade: 'Vale por 1 hora y funciona una sola vez. Si no llega en unos minutos, revisa la carpeta de spam.',
    deNovo: 'Enviar de nuevo',
    lembrou: '¿Recordaste tu contraseña?',
    entrar: 'Iniciar sesión'
  },

  cadastro: {
    titulo: 'Crea tu cuenta en Silent Puma',
    texto: '{projetos} y {paginas} páginas al mes en el plan Basic, gratis y sin tarjeta.',
    projetos: { um: '{n} proyecto', outros: '{n} proyectos' },
    ouEmail: 'o con nombre y correo',
    nome: 'Nombre',
    depois: 'Después, Stripe confirma el plan Basic sin pedir tarjeta, y vuelves a Silent Puma para definir la contraseña.',
    botao: 'Crear cuenta gratis',
    abrindoStripe: 'Abriendo Stripe…',
    consentimentoA: 'Al crear la cuenta, con Google o con correo, aceptas los',
    consentimentoE: 'y la',
    jaTemConta: '¿Ya tienes cuenta?',
    entrar: 'Iniciar sesión',
    faltaNome: 'Escribe tu nombre.',
    faltaEmail: 'Escribe un correo con el formato nombre@empresa.com.',
    emailExiste: 'Ese correo ya tiene cuenta.',
    irEntrar: 'Inicia sesión con él',
    ou: 'o',
    irSenha: 'recupera la contraseña',
    erroCheckout: 'No pudimos abrir Stripe ahora. Vuelve a intentarlo en unos instantes.',
    semContaGoogle: 'Esa cuenta de Google todavía no está registrada en Silent Puma. Crea la tuya aquí.',
    planoTitulo: 'Qué incluye el plan Basic',
    planoProjetos: 'Proyectos',
    planoPaginas: 'Páginas al mes',
    planoHistorico: 'Historial de ejecuciones',
    planoDias: { um: '{n} día', outros: '{n} días' },
    planoCreditos: 'Créditos de IA al mes',
    planoPreco: 'Precio',
    planoGratis: 'Gratis, sin tarjeta'
  },

  notas: {
    titulo: 'Lo que significan los números',
    chamada:
      'Notas técnicas de quien corre un crawler todos los días. Cada post trae el método, para que lo compruebes en vez de creerlo.',
    minutos: { um: '{n} min de lectura', outros: '{n} min de lectura' },
    lerPost: 'Leer el post',
    anteriores: 'Posts anteriores',
    semPosts: 'Todavía no hay nada publicado. Las primeras notas se están escribiendo.',
    figuraTitulo: 'Los cinco pesos del score, en puntos',
    figuraRotulo: 'Los cinco pesos del score, en puntos: {lista}.',
    figuraLegenda: 'La altura de cada barra es lo que vale el área. Juntas suman los 100 puntos de los que parte el score.',
    trilha: 'Ruta de navegación',
    nestePost: 'En este post',
    compartilhar: 'Compartir',
    copiarLink: 'Copiar enlace',
    linkCopiado: 'Enlace copiado',
    naoCopiou: 'No se pudo copiar. Copia la dirección desde la barra del navegador.',
    legendaTela: 'La portada de una ejecución de ejemplo. La altura de cada barra es el peso del área; la parte vacía de arriba es lo que perdió.',
    calcTitulo: 'Haz la cuenta',
    calcTexto: 'Indica cuántas páginas afecta cada área y mira cómo sale el score de la misma función que usa el producto.',
    calcPaginas: 'Páginas rastreadas',
    calcSemNota: 'Sin páginas, sin score',
    leiaTambem: 'Lee también',
    fimBlog: 'Mira la cuenta de tu sitio',
    fimPost: 'Mira esta cuenta en tu sitio',
    fimBotao: 'Rastrear mi sitio gratis',
    fimNota: '{paginas} páginas al mes en el plan Basic, sin tarjeta.'
  },

  home: {
    selo: 'Análisis de SEO con IA',
    tituloA: 'Descubre el ',
    tituloEm: 'potencial oculto',
    chamada:
      'Silent Puma es tu compañero de SEO con IA. Rastrea tu sitio, ordena lo que está roto y te entrega la lista que tu cliente va a preguntar.',
    comecarGratis: 'Empezar gratis',
    semCartao: 'Sin tarjeta en el plan Basic',
    paginasGratis: '3.000 páginas/mes gratis',

    sinaisPorPagina: 'Señales por página',
    secoesDeAnalise: 'Secciones de análisis',
    siteEYoutube: 'Web y YouTube',

    demoPaginas: 'páginas',
    demoScore: 'score',
    demoCriticas: 'críticas',
    demoRodando: 'rastreando',
    demoProgresso: 'PROGRESO',
    demoTituloLongo: 'título de 71 car.',
    demoSemMeta: 'sin meta desc.',
    demoOk: 'ok',
    demoLinksQuebrados: '3 enlaces rotos',

    recursosEyebrow: 'Funciones',
    recursosTituloA: 'Funciones potentes para ',
    recursosTituloEm: 'un SEO mejor',
    recursosChamada:
      'Descubre cómo Silent Puma transforma el rendimiento de tu sitio con un conjunto completo de herramientas.',
    rapidoTitulo: 'Análisis rápido',
    rapidoMeta: 'CRAWLER EN RUST · RENDERIZADO HEADLESS',
    rapidoTexto:
      'Analiza tu sitio con una velocidad y una precisión fuera de lo común. Obtén respuestas accionables en tiempo récord con nuestro motor de rastreo.',
    exportarTitulo: 'Exportación de datos',
    exportarMeta: 'CSV · EN FLUJO, DE CUALQUIER TAMAÑO',
    exportarTexto:
      'Exporta los resultados sin esfuerzo en varios formatos. Compártelos con tu equipo o con tus clientes en CSV, Excel o Google Sheets.',
    graficosTitulo: 'Gráficos interactivos',
    graficosMeta: 'FILTRA POR EJECUCIÓN, URL Y ESTADO',
    graficosTexto:
      'Visualiza tus datos en gráficos interactivos. Identifica tendencias y oportunidades con herramientas de visualización directas.',
    iaTitulo: 'Optimizaciones de IA',
    iaMeta: 'PRIORIZADAS POR IMPACTO',
    iaTexto:
      'La IA lee tu rastreo y devuelve una lista priorizada de correcciones, cada una indicando a cuántas páginas afecta. Análisis estándar o profundo, con tus créditos.',

    contatoTitulo: 'Hablemos',
    contatoChamada:
      '¿Tienes dudas? Queremos escucharte. Envíanos un mensaje y te respondemos lo antes posible.',
    respostaEmUmDia: 'RESPUESTA EN 1 DÍA HÁBIL',
    chatAoVivo: 'Chat en vivo',
    chatPlanos: 'PLANES GURU Y PRO',
    conectorMcp: 'Conector MCP',
    conectorPlanos: 'PLANES GURU, PRO Y BUSINESS',
    seuNome: 'Tu nombre',
    seuEmail: 'Tu correo electrónico',
    suaMensagem: 'Tu mensaje',
    nomePlaceholder: 'Tu nombre',
    emailPlaceholder: 'tu@empresa.com',
    mensagemPlaceholder: 'Quiero seguir 4 dominios de clientes cada mes.',
    enviando: 'Enviando…',
    enviarMensagem: 'Enviar mensaje',
    mensagemEnviada: 'Mensaje enviado. Respondemos en un día hábil.',
    mensagemFalhou: 'No pudimos enviarlo. Intenta de nuevo en un minuto.'
  },

  inicio: {
    palco: {
      titulo: 'Auditoría de SEO que se explica',
      chamada:
        'Rastreamos cada página de tu sitio o canal de YouTube, le damos una nota de 0 a 100 y te mostramos de dónde salió cada punto.',
      acao: 'Rastrear mi sitio gratis',
      nota: '{paginas} páginas al mes en el plan Basic, sin tarjeta.'
    },
    como: {
      titulo: 'De la dirección a la nota',
      intro:
        'Una ejecución es un rastreo completo del sitio, del primer enlace al último. Nada se analiza antes de que termine: un retrato a medias no dice qué mitad quedó fuera.',
      escopoTitulo: 'Tú eliges el alcance',
      escopoTexto:
        'Crea el proyecto, un sitio o un canal de YouTube, y di hasta dónde llega el rastreador. Antes de empezar, la estimación lee tu sitemap y muestra cuántas direcciones entran, con ejemplos.',
      escopoDominio: 'Todos los enlaces del dominio',
      escopoCaminho: 'Solo debajo de la ruta inicial',
      escopoSubdominios: 'Con los subdominios, que cuentan en la misma cuota',
      rastreadorTitulo: 'El rastreador pasa',
      rastreadorTexto:
        'Escrito en Rust, abre cada página como un navegador y anota 20 señales de ella, así que lo que solo se monta en el cliente se lee por lo que muestra, no por el HTML vacío. Obedece el robots.txt y cuenta cuántas páginas dejó fuera por su causa.',
      fotografiaTitulo: 'Queda una fotografía con fecha',
      fotografiaTexto:
        'Cuando termina, la ejecución guarda el sitio de ese día: una nota, cinco áreas y, en cada página, lo que falta. Un informe de marzo sigue diciendo en septiembre lo que decía en marzo.',
      fotografiaCota: 'Una página que respondió sin contenido no descuenta de la cuota',
      fotografiaRepetir: '"Repetir" rastrea exactamente las mismas páginas',
      fotografiaHistorico: 'Historial de {min} a {max} días, o sin límite en Business'
    },
    tela: {
      rotulo:
        'Pantalla de Silent Puma con una ejecución completada de {site}: nota {nota} de 100 en {paginas} páginas, y los puntos que perdió cada área.',
      site: 'Sitio',
      execucao: 'Ejecución #{n} · {data}',
      enderecoInicial: 'Dirección inicial',
      ateOnde: 'Hasta dónde llega el rastreador',
      seguirDominio: 'Seguir todos los enlaces del dominio',
      abaixoDoCaminho: 'Quedarse debajo de la ruta inicial',
      incluirSubdominios: 'Incluir subdominios',
      parametros: 'Parámetros de URL',
      descartar: 'Descartar: cada página una vez',
      manter: 'Mantener: cada filtro se vuelve una página',
      estimativa: 'El sitemap lista {total} direcciones. {casam} coinciden con tus filtros.',
      iniciar: 'Iniciar ejecución',
      rastreando: 'Rastreando',
      deTotal: 'de {total} páginas',
      headless: 'Navegador headless',
      javascript: 'JavaScript renderizado',
      robots: '{n} direcciones',
      robotsTexto: 'cerradas por el robots.txt',
      deCem: 'de 100',
      desde: '+{n} desde la ejecución #{anterior}, en las mismas páginas',
      pontosPerdidos: 'Puntos perdidos por área',
      semMeta: 'sin meta description',
      tituloLongo: 'título con {n} caracteres',
      semH1: 'sin H1'
    },
    areas: {
      titulo: 'Cinco áreas, una cuenta',
      formulaAntes: 'La nota parte de 100 y cada área pierde',
      formulaConta: 'peso × páginas con problema ÷ total',
      formulaDepois: 'Una página sin título y sin H1 cuenta una vez.',
      pontos: '{area}, {n} puntos',
      indexacao1: 'Responde con estado 2xx',
      indexacao2: 'Se renderiza y entrega contenido de verdad',
      indexacao3: 'Tiene etiqueta canonical',
      indexacao4: 'Va primero: si el rastreador no llega a la página, lo demás no importa',
      conteudo1: 'Título, descripción y H1 presentes: es lo que entra en la nota',
      conteudo2: 'Título medido contra {min} a {max} caracteres',
      conteudo3: 'Descripción contra {min} a {max}',
      conteudo4: 'Menos de {n} palabras se vuelve pedido de revisión, no regla',
      experiencia1: 'Respuesta del servidor por debajo de {lenta} s; por encima de {critica} s es crítica',
      experiencia2: 'Meta viewport presente',
      experiencia3: 'Página de menos de {mb} MB',
      experiencia4: 'Medimos el servidor, no el LCP, y el panel lo dice',
      midia1: 'Cada imagen con texto alternativo',
      midia2: 'Imágenes contadas página por página',
      midia3: 'La lista sale lista para quien la va a completar',
      links1: 'Ningún enlace roto',
      links2: 'Al menos un enlace interno: una página sin enlaces es una página huérfana',
      links3: 'Enlaces internos y externos contados por página',
      controle: {
        indexacao: 'Páginas con problema de indexación',
        conteudo: 'Páginas con problema de contenido',
        experiencia: 'Páginas con problema de experiencia',
        midia: 'Páginas con problema de medios',
        links: 'Páginas con problema de enlaces'
      },
      deTotal: '{n} de {total}',
      fecho: 'La nota no es una prueba. Es el mapa de dónde se pierden más puntos por página tocada.',
      acao: 'Ver la cuenta de mi sitio',
      statusDasPaginas: 'Estado de las páginas',
      semCanonical: 'Sin canonical',
      naoRenderizou: 'No se renderizó',
      comoAparece: 'Cómo aparece en la búsqueda',
      serpTitulo: 'Zapatillas de Running Pro X: Amortiguación Reactiva para…',
      caracteresAcima: '{n} caracteres, por encima de {max}',
      semMetaBuscador: 'Sin meta description: el buscador elige un fragmento de la página.',
      semH1: 'Sin H1',
      tempoDeResposta: 'Tiempo de respuesta del servidor',
      lentasAcima: 'Lentas, por encima de {s} s',
      semViewport: 'Sin viewport',
      imagensDaPagina: 'Imágenes de una página de producto',
      semAlt: 'sin alt',
      comAlt: 'con alt',
      paginasSemAlt: 'Páginas sin alt',
      linksQuebrados: 'Enlaces rotos',
      menuDoBlog: 'Los tres están en el menú del blog, en {n} páginas.',
      semLinkInterno: 'Sin enlace interno'
    },
    saidas: {
      titulo: 'Lo que sale de cada ejecución',
      nome: {
        relatorio: 'Informe',
        correcoes: 'Correcciones de la IA',
        naSuaIa: 'En tu IA',
        planilha: 'Hoja de cálculo',
        canal: 'Canal de YouTube'
      },
      legenda: {
        relatorio:
          'Toda ejecución completada se convierte en un informe de auditoría técnica para entregar al cliente. Se imprime en PDF desde el navegador, con texto buscable.',
        correcoes:
          'La IA lee el rastreo y devuelve de 4 a 10 correcciones, por impacto y, con el mismo impacto, por el menor esfuerzo. Cada una dice cuántas páginas toca.',
        naSuaIa:
          'El conector lleva tus rastreos a Claude, ChatGPT o Cursor. Por defecto solo lee, y leer no consume créditos ni cuota.',
        planilha:
          'Todas las páginas en CSV, cada una con lo que midió el rastreador y los problemas que tiene. La exportación sale en flujo, así que funciona con cualquier tamaño.',
        canal:
          'Un proyecto también puede ser un canal. La nota del canal tiene cuatro áreas: metadatos {metadados}, interacción {engajamento}, rendimiento {desempenho} y publicación {publicacao}.'
      },
      relTitulo: 'Informe de auditoría técnica',
      relMeta: '{site} · ejecución #{n} · {paginas}',
      resumo: 'Resumen',
      relResumo:
        'La indexación está sana: el {pct}% de las páginas responde 2xx y casi todas tienen canonical. Lo que más puntos cuesta es el contenido, con {n} páginas de producto sin meta description.',
      deOndeSairam: 'De dónde salieron los puntos',
      colArea: 'Área',
      colPeso: 'Peso',
      colPaginas: 'Páginas',
      colPerdidos: 'Perdidos',
      total: 'Total',
      prioridades: 'Prioridades',
      ia1: 'Escribir la meta description de las páginas de producto',
      ia2: 'Cambiar los tres enlaces del menú del blog que llevan a 404',
      ia3: 'Dar canonical a las páginas de filtro de categoría',
      ia4: 'Investigar la respuesta lenta de las páginas de categoría',
      ia5: 'Completar el texto alternativo de las fotos de producto',
      iaTitulo: 'Análisis de IA',
      iaMeta: 'Estándar · {custo} · versión 2 · en español',
      iaResumo:
        'La indexación está sana. Lo que más pesa es el contenido: las páginas de producto se publicaron sin descripción, y el buscador está eligiendo fragmentos por su cuenta.',
      mcpPergunta: '¿Qué páginas de la tienda tienen un enlace roto?',
      mcpConsultou: 'Consultó Silent Puma:',
      mcpExecucao: 'ejecución #{n}',
      mcpResposta1: '{n} páginas apuntan a tres direcciones que responden 404, todas en el menú lateral del blog:',
      mcpResposta2: 'Corregir el menú resuelve las {n} de una vez. Otras {m} páginas no reciben ningún enlace interno.',
      mcpRodape: 'Conector de lectura: ninguna herramienta crea proyectos, borra ejecuciones ni toca tu cuenta.',
      canalMeta: 'Canal de YouTube · {videos} videos · ejecución #{n}',
      video1: 'Cómo elegir zapatillas para carreras largas',
      video2: 'Entrenamiento por intervalos en 20 minutos',
      video3: 'Unboxing: Pro X',
      tituloAcima: 'Título con {n} caracteres, por encima de {max}',
      engajamentoAbaixo: 'Interacción del {n}%, por debajo del {min}%',
      descricaoCurta: 'Descripción con menos de {min} caracteres'
    },
    degraus: {
      titulo: 'Empieza en el primer escalón',
      anual: 'Anual, {n} meses gratis',
      paraSempre: 'para siempre',
      comecarGratis: 'Empezar gratis',
      assinar: 'Contratar {plano}',
      falar: 'Hablar con nosotros',
      publico: {
        Basic: 'Para revisar tu propio sitio.',
        Guru: 'Para quien cuida algunos sitios.',
        Pro: 'Para agencias con varios clientes.',
        Business: 'Para operaciones sin techo de páginas.'
      }
    },
    perguntas: {
      titulo: 'Preguntas directas',
      p1: '¿Qué cuenta como página?',
      r1: 'Cada dirección rastreada en el mes. Una página que respondió 2xx pero no entregó contenido, incluso en el segundo intento, no descuenta de la cuota. El mes se reinicia en tu fecha de facturación.',
      p2: '¿Respetan el robots.txt?',
      r2: 'Sí. El rastreador no entra en nada detrás de un inicio de sesión ni en páginas que el sitio pide no indexar, y la ejecución dice cuántas direcciones quedaron fuera por eso.',
      p3: '¿Lee páginas armadas con JavaScript?',
      r3: 'Sí. Cada página se renderiza como en un navegador, así que vale lo que muestra, no el HTML vacío que devuelve.',
      p4: '¿El tiempo de carga es el Core Web Vitals?',
      r4: 'No. Medimos la respuesta del servidor, no el Largest Contentful Paint. Por encima de {lenta} s la página es lenta; por encima de {critica} s, crítica.',
      p5: '¿Cuánto cuesta un análisis de IA?',
      r5: 'El estándar cuesta un crédito y el profundo, dos. Nunca se ejecuta solo, solo cuando lo pides. Basic incluye {basic} créditos al mes, Guru {guru} y Pro {pro}.',
      p6: '¿Qué va al proveedor de IA?',
      r6: 'Métricas agregadas y una muestra de direcciones. Nunca los datos de tu cuenta ni tus credenciales.',
      p7: '¿Con qué IA funciona el conector?',
      r7: 'Claude, ChatGPT y Cursor, en los planes Guru, Pro y Business. Por defecto solo lee, y leer no consume créditos ni cuota.',
      p8: '¿Cómo comparo dos fechas?',
      r8: 'Usa "Repetir" en la lista de ejecuciones: rastrea exactamente las páginas de la ejecución anterior, y la diferencia de nota pasa a medir el sitio, no la muestra.',
      p9: '¿Puedo entregar el informe al cliente?',
      r9: 'Sí. Toda ejecución completada se convierte en un informe de auditoría técnica, impreso en PDF desde el navegador, con texto buscable.',
      p10: '¿Puedo cancelar cuando quiera?',
      r10: 'Sí. Cancelar mantiene el plan hasta el final del período ya pagado.'
    },
    contato: {
      titulo: '¿Te quedó alguna duda?',
      chamada: 'Escríbenos: respondemos en un día hábil.',
      mensagem: 'Tu mensaje',
      mensagemExemplo: 'Quiero seguir 4 dominios de clientes cada mes.',
      nome: 'Tu nombre',
      email: 'Tu correo',
      emailExemplo: 'tu@empresa.com',
      ouEscreva: 'O escribe directamente a',
      enviar: 'Enviar mensaje',
      enviando: 'Enviando…',
      enviada: 'Mensaje enviado. Respondemos en un día hábil.',
      falhou: 'No pudimos enviarlo. Intenta de nuevo en un minuto.'
    },
    cabecalho: {
      navegacao: 'Principal'
    },
    fecho: {
      navegacao: 'Secciones de la página',
      comoFunciona: 'Cómo funciona',
      cincoAreas: 'Las cinco áreas',
      oQueSai: 'Lo que sale',
      perguntas: 'Preguntas',
      chat: 'Chat en vivo en los planes Guru y Pro',
      conta: 'Cuenta',
      criarConta: 'Crear cuenta gratis',
      fotoAlt: 'Puma caminando de noche hacia la cámara, fotografiado por una cámara trampa.',
      fotoLegenda:
        'Santa Monica Mountains, 11 de abril de 2011, 1:25. Una cámara trampa registra lo que pasa, en silencio, con fecha y hora.',
      fotoCredito: 'Foto: National Park Service, dominio público, vía'
    }
  },

  precos: {
    titulo: 'Elige tu plan',
    chamada: 'Empieza a optimizar tu sitio hoy, con planes flexibles',
    ciclo: 'Ciclo de facturación',
    mensal: 'Mensual',
    anual: 'Anual',
    mesesGratis: '{n} meses gratis',
    maisPopular: 'Más popular',
    personalizado: 'A medida',
    porMes: '/mes',
    moedaSimbolo: 'US$',
    anualDetalhe: '/mes, facturado al año (US$ {valor})',
    carregando: 'Cargando…',
    faleConosco: 'Hablemos',
    comecar: 'Empezar'
  },

  plano: {
    basicDescricao: 'Perfecto para empezar',
    basicDestaque: 'Panel del sitio y del canal',
    guruDescricao: 'Ideal para equipos en crecimiento',
    proDescricao: 'Para uso profesional',
    businessDescricao: 'Para grandes empresas',
    guruDestaque: 'Historial de 30 días y comparación entre ejecuciones',
    proDestaque: 'Integraciones con Google Analytics, Search Console y YouTube Analytics',
    businessDestaque: 'Todo lo de Pro',
    conectorMcp: 'Conector MCP para tu IA',
    suporteEmail: 'Soporte por correo',
    suporteChat: 'Soporte por chat',
    suportePrioritario: 'Soporte prioritario por chat',
    suporteDedicado: 'Soporte dedicado',
    projetos: { um: '{n} proyecto', outros: '{n} proyectos' },
    projetosIlimitados: 'Proyectos ilimitados',
    paginasPorMes: '{n} páginas/mes',
    creditosPorMes: '{n} créditos de IA/mes',
    paginasIlimitadas: 'Páginas ilimitadas',
    creditosIlimitados: 'Créditos de IA ilimitados',
    retencao: 'Retención de {n} días',
    retencaoIlimitada: 'Retención ilimitada'
  },

  planosTela: {
    publicoTitulo: 'Elige tu plan',
    publicoChamada: 'Empieza a optimizar tu sitio hoy. Cancela cuando quieras.',
    titulo: 'Tu plan',
    gratuitoParaSempre: ', gratis para siempre',
    cobradoStripe: ', facturado por Stripe',
    faleConosco: 'Hablemos',
    comecar: 'Empezar',
    planoAtual: 'Plan actual',
    cancelarAssinatura: 'Cancelar suscripción',
    melhorar: 'Mejorar',
    rebaixar: 'Bajar de plan',
    atual: 'actual',
    assinaturaCancelada: 'Suscripción cancelada.',
    trocaRecebida: 'Cambio de plan confirmado. El plan nuevo aparecerá aquí en un momento.',
    cobrancasRecentes: 'Cargos recientes',
    historicoCompleto: 'Historial completo',
    basicSemCobranca: 'El plan Basic es gratuito — no hay nada que cobrar.',
    semCobrancas: 'Todavía no hay cargos registrados.'
  },

  pagamentos: {
    titulo: 'Historial de cargos',
    planos: 'Planes',
    basicGratis: 'El plan Basic es gratuito — no se cobra nada.',
    todasCobrancas: 'Todos los cargos que Stripe hizo en esta cuenta.',
    semCobrancasBasic: 'Ningún cargo en el plan Basic.',
    semCobrancas: 'Todavía no hay cargos registrados.',
    verPlanos: 'Ver planes',
    data: 'Fecha',
    descricao: 'Descripción',
    valor: 'Importe',
    status: 'Estado',
    recibo: 'Recibo',
    ver: 'Ver',
    pago: 'pagado',
    pendente: 'pendiente',
    falhou: 'falló',
    assinatura: 'Suscripción Silent Puma'
  },

  criar: {
    titulo: 'Crear nuevo proyecto',
    chamada: 'Configura tu nuevo proyecto de seguimiento',
    nome: 'Nombre del proyecto',
    nomePlaceholder: 'Ej.: Mi canal o sitio',
    tipo: 'Tipo de proyecto',
    canalYoutube: 'Canal de YouTube',
    site: 'Sitio web',
    url: 'URL',
    urlYoutube: 'https://www.youtube.com/@...',
    urlSite: 'https://www.misitio.com',
    ajudaYoutube: 'Escribe la URL de tu canal de YouTube',
    ajudaSite: 'Escribe la URL de tu sitio',
    criando: 'Creando…',
    criar: 'Crear proyecto'
  },

  crawl: {
    carregando: 'Cargando…',
    titulo: 'Configuración de la ejecución',
    chamada: 'Configura la ejecución para {nome}',
    tipoDeProjeto: 'Tipo de proyecto',
    youtube: 'YouTube',
    site: 'Sitio web',
    urlAlvo: 'URL de destino',
    usoDoPlano: 'Uso del plan',
    itensUsados: '{usados} de {total} elementos usados',
    ilimitado: 'Ilimitado',
    nomeDaRun: 'Nombre de la ejecución',
    nomePlaceholder: 'Ej.: Revisión diaria o Análisis semanal',
    nomeAjuda: 'Dale un nombre descriptivo para reconocer la ejecución después',
    limites: 'Límite del rastreo',
    disponivel: '(Disponible: {n})',
    rastrearAte: 'Rastrear hasta',
    urls: 'URLs',
    limiteAjuda: 'Define el número máximo de páginas a rastrear en esta ejecución',
    tudoSite: 'Rastrear todo el sitio',
    tudoCanal: 'Rastrear todo el canal',
    tudoAjuda:
      'El rastreo continúa hasta agotar el sitio o la cuota de tu plan, lo que ocurra primero.',
    tudoAjudaCanal:
      'El rastreo continúa hasta agotar el canal o la cuota de tu plan, lo que ocurra primero.',
    tudoTeto: 'Hay un tope de seguridad de {n} páginas por ejecución, incluso en plan ilimitado.',
    tudoEstimativa: 'Estimadas {n} páginas, y tienes {d} disponibles.',
    tudoEstimativaExcede:
      'Estimadas {n} páginas, más que las {d} disponibles — el rastreo se detendrá en tu cuota.',
    iniciar: 'Iniciar ejecución',

    configuracao: 'Configuración del rastreo',
    comportamento: 'Comportamiento del rastreo',
    seguirTudo: 'Seguir todos los enlaces',
    ficarNoDiretorio: 'Quedarse en el directorio actual',
    incluirSubdominios: 'Incluir subdominios',
    seuDominio: 'tu dominio',
    ajudaDiretorio:
      'Solo direcciones bajo la ruta inicial, en {raiz} o www.{raiz}. Úsalo para mirar una sección sin rastrear el resto.',
    ajudaSubdominio:
      'Añade cualquier subdominio — blog.{raiz} y similares — a {raiz} y www.{raiz}. Todos cuentan en la misma cuota de páginas.',
    ajudaTudo: 'Sigue todo enlace encontrado, siempre que se quede en {raiz} o www.{raiz}.',

    parametros: 'Parámetros de URL',
    manterTodos: 'Mantener todos los parámetros',
    ignorarTodos: 'Ignorar todos los parámetros',
    personalizado: 'Configuración personalizada',
    ajudaIgnorar:
      'Todo lo que va después del "?" se descarta, así la misma página se rastrea una vez. Es el valor seguro para la mayoría de los sitios.',
    ajudaPersonalizado:
      'Reservado para una regla por parámetro. Hoy se comporta como "Mantener todos".',
    ajudaManter:
      'Cada combinación de parámetros cuenta como una página distinta. En una tienda con filtros de color y talla, un solo producto puede consumir decenas de páginas de tu cuota.',

    apenasUrls: 'Rastrear solo URLs',
    tipoDeComparacao: 'Tipo de coincidencia',
    apenasPlaceholder: '{exemplo}  — déjalo vacío para rastrear todo el sitio',
    apenasAjuda: 'Separa los términos con comas; se rastrea la página que coincida con cualquiera.',
    excluirUrls: 'Omitir URLs que contengan',
    excluirPlaceholder: '/institucional, /politica-de-privacidad',
    excluirAjuda: 'Las exclusiones tienen prioridad sobre el campo de arriba.',
    exclusoesComuns: 'Exclusiones comunes',
    exclusoesAjuda: 'Estas páginas rara vez tienen valor de SEO y consumen tu cuota.',

    estimando: 'Consultando el sitio…',
    estimar: 'Estimar páginas coincidentes',
    estimativaAjuda:
      'Leído del sitemap del sitio. Es una estimación: los sitemaps se desactualizan y puede haber páginas sin listar.',
    correspondem: {
      um: '≈ {n} página coincide con tus filtros',
      outros: '≈ {n} páginas coinciden con tus filtros'
    },
    deUrlsNoSitemap: 'De {encontradas} URLs listadas en {sitemaps}',
    umSitemap: 'el sitemap',
    variosSitemaps: '{n} sitemaps',
    sitemapTruncado: ' (el sitio tiene más de lo que pudimos leer)',
    limiteCobreParte: ' Tu límite de {n} cubre parte de eso.',
    pisoTitulo: 'Al menos {n} páginas coinciden',
    pisoDetalhe:
      'Este sitio no tiene sitemap, así que esto cuenta solo los enlaces de la página de inicio. El número real es muy probablemente mayor.',
    reescritoDetalhe:
      'De {encontradas} URLs. El sitemap de este sitio las lista en {host} — la plataforma donde corre — y las mismas direcciones responden en tu propio dominio, así que las contamos allí.',
    outroHostTitulo: 'No se puede estimar con este sitemap',
    outroHostDetalhe:
      'El sitemap lista {encontradas} URLs, pero todas están en {host} y no en el dominio de tu proyecto — algo común cuando una tienda corre en una plataforma alojada. Tus filtros apuntan al dominio del proyecto, así que los dos no coinciden. El rastreo en sí sigue los enlaces que encuentra en tu sitio.',
    nenhumaDetalhe:
      'No se encontró sitemap, y la página de inicio no respondió dentro del tiempo límite, ni siquiera con un error. Puede ser una inestabilidad del sitio: intenta estimar de nuevo en unos instantes. Si sigue pasando, revisa la dirección del proyecto.',
    nenhumaBloqueado:
      'La página de inicio respondió {status}: el sitio está rechazando nuestro rastreador, y el rastreo chocará con la misma barrera.',

    avancado: 'Configuración avanzada',
    padroesPermitidos: 'Patrones de URL permitidos (regex)',
    remover: 'Quitar',
    adicionarPadrao: 'Añadir patrón'
  },

  filtro: {
    nenhum: 'ningún filtro',
    paginacao: 'Paginación',
    paginacaoAjuda:
      'Páginas 2, 3, 4… de un listado. Repiten los mismos productos y multiplican tu conteo de páginas.',
    busca: 'Búsqueda y orden',
    buscaAjuda:
      'Resultados de búsqueda y listados ordenados o filtrados. En una tienda con facetas pueden ser miles de URLs mostrando el mismo catálogo.',
    conta: 'Carrito y cuenta',
    contaAjuda: 'Carrito, pago, inicio de sesión y cuenta. No están hechas para indexarse.',
    blog: 'Blog',
    blogAjuda: 'Útil cuando quieres mirar solo el catálogo.',

    contendo: 'que contengan',
    contendoExemplo: '/producto, /categoria',
    contendoAjuda:
      'El término aparece en cualquier parte de la URL. Es la opción más amplia — "/p" también coincide con "/politica-de-privacidad".',
    comecandoCom: 'que empiecen por',
    comecandoExemplo: '/tienda, /catalogo',
    comecandoAjuda: 'Lee a partir del dominio. Úsalo para rastrear una sección del sitio.',
    terminandoCom: 'que terminen en',
    terminandoExemplo: '/p',
    terminandoAjuda:
      'La URL termina con el término. Así se aísla la página de producto de VTEX con "/p" sin atrapar "/politica-de-privacidad".',
    igualA: 'igual a',
    igualExemplo: '/sobre, /contacto',
    igualAjuda: 'Solo se rastrean estas direcciones exactas.'
  },

  metrica: {
    titulo: 'Título',
    descricao: 'Descripción',
    h1: 'H1',
    thumbnail: 'Miniatura',
    comAlt: 'Con alt',
    semAlt: 'Sin alt',
    interno: 'Internos',
    externo: 'Externos',
    views: 'Visualizaciones',
    curtidas: 'Me gusta'
  },

  secao: {
    vazioVideos: 'Ningún video recogido en esta selección.',
    vazioData: 'Ningún video de esta selección tiene fecha de publicación registrada.',
    semCanonical: 'Sin etiqueta canónica',
    semTitulo: 'Sin título',
    semDescricao: 'Sin descripción',
    semH1: 'Sin H1',
    tituloForaDaFaixa: 'Título fuera de rango',
    descricaoForaDaFaixa: 'Descripción fuera de rango',
    conteudoRaso: 'Contenido escaso',
    semViewport: 'Sin viewport',
    semOgImagem: 'Sin og:image',
    ogImagemRepetida: 'og:image repetida',
    ytSemDescricao: 'Sin descripción',
    descricaoCurta: 'Descripción corta',
    tituloLongo: 'Título largo',
    semThumbnail: 'Sin miniatura',
    totalVideos: 'Videos',
    totalViews: 'Visualizaciones',
    mediaPorVideo: 'Media por video',
    abaixoDaMediaNota: '{n} por debajo de la media',
    maisVistos: 'Más vistos',
    taxaGeral: 'Interacción general',
    taxaGeralNota: 'saludable a partir del {n}%',
    engajamentoBaixo: 'Interacción baja',
    maisEngajados: 'Con más interacción',
    semData: 'Sin fecha'
  },

  painelSite: {
    titulo: 'Panel de análisis del sitio',
    abaVisao: 'Resumen',
    abaIndexacao: 'Indexación',
    abaConteudo: 'Contenido',
    abaExperiencia: 'Experiencia',
    abaMidia: 'Medios',
    abaLinks: 'Enlaces',
    abaTrafego: 'Búsqueda y tráfico',
    filtros: 'Filtros',
    tempoCarga: 'Tiempo de carga',
    abaDados: 'Datos',
    paginasRastreadas: 'Páginas rastreadas',
    cargaMedia: 'Tiempo medio de carga',
    tamanhoMedio: 'Tamaño medio de página',
    score: 'Score de SEO',
    scoreAjuda:
      'Parte de 100 y pierde una parte del peso de cada área en proporción a las páginas afectadas: indexación 25, contenido 30, experiencia 20, enlaces 15, medios 10. Solo vale leído contra otra ejecución del mismo sitio — el informe muestra esa comparación.',
    semTitulo: 'Sin título',
    semDescricao: 'Sin descripción',
    execucao: 'Ejecución:',
    execucaoSemNome: 'Ejecución sin nombre',
    url: 'URL:',
    igual: 'Igual a',
    contem: 'Contiene',
    naoContem: 'No contiene',
    comecaCom: 'Empieza por',
    terminaCom: 'Termina en',
    urlPlaceholder: 'Escribe la URL...',
    status: 'Estado:',
    todosStatus: 'Todos los estados',
    status200: '200 - Éxito',
    status301: '301 - Movido permanentemente',
    status302: '302 - Encontrado',
    status400: '400 - Solicitud inválida',
    status404: '404 - No encontrado',
    status500: '500 - Error del servidor',
    tempoDeCarga: 'Tiempo de carga (ms):',
    limpar: 'Limpiar',
    semExecucoesConcluidas:
      'Ninguna ejecución completada en este proyecto. El panel mide una ejecución a la vez — ejecute una para ver los números.',
    paginasComErro: 'Páginas con error',
    paginasComErroAjuda:
      'Respuestas 4xx y 5xx. El buscador no indexa lo que no puede abrir, y un enlace interno que apunta aquí desperdicia rastreo.',
    grafico: {
      desempenho: 'Rendimiento',
      seo: 'SEO en la página',
      arquitetura: 'Contenido y arquitectura',
      cargaTitulo: 'Distribución del tiempo de carga',
      cargaNota:
        'El color es juicio: verde dentro de la meta, rojo por encima de 3 segundos.',
      statusTitulo: 'Códigos HTTP',
      statusNota: 'Sobre las respuestas de esta ejecución.',
      statusCentro: 'respuestas',
      problemasTitulo: 'Problemas de SEO',
      problemasNota:
        'Críticos primero, después avisos, cada grupo por volumen; la barra es la proporción de páginas rastreadas. Haga clic en un problema para ver sus páginas en la tabla.',
      problemasVazio: 'Ningún problema en las áreas medidas.',
      canonical: 'Etiqueta canónica',
      coberturaTitulo: 'Cobertura de meta etiquetas',
      coberturaNota:
        'Presencia por etiqueta. La canónica está aquí porque es la que separa una página duplicada de una nueva.',
      profundidadeTitulo: 'Profundidad de clic',
      profundidadeNota:
        'Cuántos clics desde la URL inicial hasta la página. A partir de cuatro se vuelve difícil de alcanzar, para la persona y para el rastreador.',
      profundidadeVazio:
        'Esta ejecución no registró profundidad. Las repeticiones de ejecuciones anteriores a esta medida no tienen nivel del que heredar.',
      profundidadeRaiz: 'inicial',
      acessoTitulo: 'Medios y acceso',
      acessoNota: 'Tres presencias que deciden si la página se encuentra y se entiende.',
      imagensComAlt: 'Imágenes con texto alternativo',
      comLinkInterno: 'Páginas con enlace interno de salida',
      comViewport: 'Páginas con viewport',
      com: 'con',
      sem: 'sin'
    }
  },

  painelYt: {
    titulo: 'Panel de YouTube',
    execucao: 'Ejecución:',
    execucaoNumero: 'Ejecución {n}',
    buscarTitulo: 'Buscar por título:',
    tituloPlaceholder: 'Escribe el título...',
    faixaViews: 'Rango de visualizaciones:',
    faixaCurtidas: 'Rango de me gusta:',
    faixaComentarios: 'Rango de comentarios:',
    filtros: 'Filtros',
    videos: 'Videos',
    score: 'Puntuación del canal',
    scoreAjuda:
      'Parte de 100 y pierde una parte del peso de cada área en proporción a los videos afectados: metadatos 35, interacción 30, rendimiento 25, publicación 10. Solo tiene sentido leída contra otra ejecución del mismo canal.',
    semExecucoesConcluidas:
      'Ninguna ejecución completada en este proyecto. El panel mide una ejecución a la vez — inicia una para ver los números.',
    grafico: {
      porMesTitulo: 'Visualizaciones por video publicado',
      porMesNota:
        'Media por video del mes, y no el total: el total premiaría al mes en que más se publicó.',
      porMesVazio: 'Ningún video de esta ejecución tiene fecha de publicación para agrupar por mes.',
      tagsTitulo: 'Etiquetas con más interacción',
      tagsNota:
        'Sobre qué interactúa el canal, no sobre qué publica. La tasa es agregada, y una etiqueta de un solo video queda fuera.',
      tagsVazio: 'Ninguna etiqueta se repite en dos videos con visualizaciones.',
      distribuicaoTitulo: 'Distribución de visualizaciones',
      distribuicaoNota: 'Cuántos videos hay en cada rango de alcance.',
      maisVistosNota: 'Los cinco de mayor alcance en esta ejecución.',
      dispersaoTitulo: 'Visualizaciones × me gusta',
      dispersaoNota:
        'Un punto por encima de la tendencia es un video que interactuó más de lo que su alcance sugeriría.',
      dispersaoVazio: 'Muy pocos videos con visualizaciones para dibujar la nube.',
      maisEngajadosNota: 'Me gusta y comentarios sobre visualizaciones, por video.',
      atencaoTitulo: 'Puntos de atención',
      atencaoNota:
        'Ordenado por volumen. Las etiquetas quedan fuera: YouTube dice que tienen un papel mínimo en el descubrimiento.',
      atencaoVazio: 'Ningún punto de atención en las áreas medidas.',
      porDiaTitulo: 'Publicación por día de la semana',
      porDiaNota: 'Media de visualizaciones por video publicado ese día, y no el total del día.'
    }
  },

  colunaYt: {
    legenda: 'Subtítulos',
    comLegenda: 'sí',
    semLegenda: 'no',
    tags: 'Etiquetas',
    comentarios: 'Comentarios',
    publicadoEm: 'Publicado el',
    videoId: 'ID del video',
    engajamento: 'Interacción',
    naoCurtidas: 'No me gusta',
    url: 'URL',
    canal: 'Canal',
    execucao: 'Ejecución'
  },

  tabela: {
    colEstrutura: 'Estructura',
    colAutor: 'Autor',
    colAtualizado: 'Actualizado el',
    colDensidade: 'Contenido en main',
    colProduto: 'Schema de producto',
    estrutura: {
      semPreco: 'sin precio',
      semDisponibilidade: 'sin disponibilidad',
      semMarca: 'sin marca',
      semAvaliacao: 'sin valoración',
      ok: 'ok',
      semHeadings: 'sin títulos',
      semH1: 'sin H1',
      multiplosH1: 'varios H1',
      saltoDeNivel: 'salto de nivel'
    },
    min: 'Mín',
    max: 'Máx',
    selecionarColunas: 'Seleccionar columnas',
    colunasVisiveis: 'Columnas visibles',
    selecionarTodas: 'Seleccionar todas',
    baixarCsv: 'Descargar CSV',
    linhasPorPagina: 'Filas por página:',
    intervalo: '{de}-{ate} de {total}',
    colUrl: 'URL',
    colStatus: 'Estado',
    colCarga: 'Respuesta del HTML (ms)',
    colTamanho: 'Tamaño (KB)',
    colScore: 'Score de SEO',
    colTitulo: 'Título',
    colDescricao: 'Meta description',
    colH1: 'Etiquetas H1',
    colLinksQuebrados: 'Enlaces rotos',
    colLinksQuebradosProprios: 'Enlaces rotos (propios)',
    colCliques: 'Clics',
    colImpressoes: 'Impresiones',
    colCtr: 'CTR',
    colPosicao: 'Posición media',
    colSessoes: 'Sesiones',
    colConversoes: 'Conversiones',
    colRejeicao: 'Rebote',
    colEngajamento: 'Interacción/sesión',
    colViewsPorSessao: 'Páginas/sesión'
  },

  otim: {
    titulo: 'Optimizaciones recomendadas',
    execucao: 'Ejecución: {nome}',
    carregando: 'Cargando…',
    analisando: 'Analizando…',
    gerar: 'Generar',
    gerarDeNovo: 'Generar de nuevo',
    custo: { um: '{n} crédito', outros: '{n} créditos' },
    comCusto: '{acao} ({custo})',
    padraoRotulo: 'Análisis estándar',
    padraoDescricao: 'Profundidad suficiente para revisiones de rutina y ejecuciones recurrentes.',
    profundaRotulo: 'Análisis profundo',
    profundaDescricao: 'Más razonamiento en sitios complejos. Cuesta más créditos.',
    foco: 'Enfoque de este análisis',
    opcional: '(opcional)',
    focoExemploSite:
      'p. ej.: prioriza las páginas de producto, ignora el blog, el sitio es mobile-first.',
    focoExemploYoutube:
      'p. ej.: es un canal de tutoriales, quiero más suscriptores, céntrate en los videos de 2026.',
    demora:
      'Esto tarda unos minutos. Deja esta página abierta — el resultado aparece aquí cuando esté listo.',
    versoes: 'Versiones de esta ejecución:',
    maisRecente: 'más reciente',
    semModelo: 'modelo no registrado',
    focoUsado: 'Enfoque pedido en esta versión:',
    vazio: 'Todavía no se ha generado ninguna optimización para esta ejecución.',
    vazioAjudaSite:
      'La IA lee los datos de tu rastreo y devuelve una lista priorizada de qué corregir primero, con el número de páginas afectadas.',
    vazioAjudaYoutube:
      'La IA lee los videos recogidos y devuelve una lista priorizada de qué ajustar primero, con el número de videos afectados.',
    resumo: 'Resumen',
    impacto: 'Impacto {nivel}',
    esforco: 'Esfuerzo {nivel}',
    oQueFazer: 'Qué hacer:',
    geradoEm: 'Generado el {data} · {tokens} tokens',
    voltar: 'Volver a los proyectos',

    nivelAlto: 'alto',
    nivelMedio: 'medio',
    nivelBaixo: 'bajo',
    paginas: { um: '{n} página', outros: '{n} páginas' },
    videos: { um: '{n} video', outros: '{n} videos' },

    catIndexacao: 'Indexación',
    catConteudo: 'Contenido',
    catExperiencia: 'Experiencia',
    catMidia: 'Medios',
    catLinks: 'Enlaces',
    catEstruturados: 'Datos estructurados',
    catDesempenho: 'Rendimiento',
    catMetadados: 'Metadatos',
    catEngajamento: 'Interacción',
    catPublicacao: 'Publicación'
  },

  relatorio: {
    voltar: '← Volver a las ejecuciones',
    execucaoDoRelatorio: 'Ejecución de este informe',
    salvarPdf: 'Guardar en PDF',
    carregando: 'Cargando…',
    tipo: 'Auditoría técnica',
    seloGerado: 'Silent Puma · informe generado el {data}',
    titulo: 'Informe de auditoría técnica',
    tituloDocumento: 'Silent Puma — {projeto} — ejecución {run}',
    opcaoExecucao: '#{id} — {nome} — {data}',
    semRunConcluida:
      'Este proyecto todavía no tiene una ejecución completada. El informe se arma a partir de un rastreo terminado —',
    comeceUma: 'inicia uno',
    eVolte: 'y vuelve cuando termine.',

    paginasAnalisadas: 'Páginas analizadas',
    acessiveis: 'Accesibles',
    score: 'Score de SEO',
    problemasEncontrados: 'Problemas encontrados',
    rastreadoEm: 'Rastreado el',

    resumo: 'Resumen',
    prioridades: 'Prioridades',
    oQueFazer: 'Qué hacer',
    onde: 'Dónde',
    alcance: 'Alcance',

    metricas: 'Métricas técnicas',
    metrica: 'Métrica',
    medido: 'Medido',
    referencia: 'Referencia',
    veredicto: 'Veredicto',
    tituloCanal: 'Auditoría de canal',
    videosAnalisados: 'Vídeos analizados',
    coletadoEm: 'Recopilado el',
    tag: 'Etiqueta',
    videos: 'Vídeos',
    metodologiaColeta:
      'La recopilación recorrió {paginas} del canal {alvo} el {data}, en la ejecución n.º {run}. Los números de este informe son la foto de aquel momento: visualizaciones, me gusta y comentarios siguen cambiando después.',
    metodologiaFaixasCanal:
      'Un título se considera largo por encima de {titulo} caracteres, que es donde YouTube empieza a truncarlo en la búsqueda y en las sugerencias. La descripción se considera corta por debajo de {descricao} caracteres, el fragmento que aparece en el resultado de búsqueda. La interacción es la suma de me gusta y comentarios sobre visualizaciones, y {engajamento}% es la convención de mercado para una tasa saludable — referencia, no meta.',
    metodologiaCanalNota:
      'Las etiquetas entran como información de repertorio, no como problema a corregir: el propio YouTube afirma que tienen un papel mínimo en el descubrimiento. La tabla de etiquetas mide la interacción de los vídeos que las llevan, lo que habla del tema, no de la etiqueta.',
    scoreCanal: 'Puntuación del canal',
    porAreaNotaCanal:
      'Un vídeo puede aparecer en más de un área — el mismo vídeo puede estar sin descripción y con poca interacción.',
    scoreNotaCanal:
      'La puntuación parte de 100 y pierde una parte del peso de cada área en proporción a los vídeos afectados: metadatos 35, interacción 30, rendimiento 25, publicación 10. Un vídeo con tres defectos de metadatos cuenta una vez — es un vídeo a arreglar, no tres.',
    vOk: 'ok',
    vAviso: 'revisar',
    vCrit: 'crítico',

    linhaAcessiveis: 'Páginas respondiendo 2xx',
    linhaComTitulo: 'Páginas con título',
    linhaTituloNaFaixa: 'Títulos dentro del rango',
    linhaComDescricao: 'Páginas con meta description',
    linhaDescricaoNaFaixa: 'Descripciones dentro del rango',
    linhaComH1: 'Páginas con H1',
    linhaComCanonical: 'Páginas con etiqueta canónica',
    linhaComViewport: 'Páginas con meta viewport',
    linhaRespostaMedia: 'Respuesta media del servidor',
    linhaLentas: 'Páginas más lentas que 3s',
    linhaPesoMedio: 'Peso medio de la página',
    linhaComAlt: 'Imágenes con texto alternativo',
    linhaLinksQuebrados: 'Páginas con enlaces rotos',
    linhaSemLinkInterno: 'Páginas sin enlace interno',
    linhaSemRender: 'Páginas que no renderizaron',
    refCaracteres: '{min}–{max} caracteres',
    refAbaixoDe: 'por debajo de {n}',

    porArea: 'Problemas por área',
    porAreaNota:
      'Una página puede aparecer en más de un área — la misma página puede estar sin título y cargando despacio.',

    scoreEntreRuns: 'Score a lo largo de las ejecuciones',
    de100: 'de 100',
    desdeRun: '{sinal}{n} desde la ejecución #{id}',
    scoreDaBarra: 'Ejecución #{id}: {score}',
    scoreNota:
      'El score parte de 100 y pierde una parte del peso de cada área en proporción a las páginas afectadas: indexación 25, contenido 30, experiencia 20, enlaces 15, medios 10. Una página con tres problemas en la misma área cuenta una vez — es una página que corregir, no tres.',
    mesmaAmostra:
      'Esta ejecución repitió exactamente las páginas de la ejecución #{id}, así que la diferencia de arriba refleja cambios en el sitio — no una muestra distinta.',
    amostraDiferente:
      'Atención: la ejecución #{id} cubrió {anteriores} páginas y esta cubrió {atuais}. Cada ejecución descubre las páginas a partir de la URL inicial, así que un conjunto distinto puede mover el score por sí solo — usa Repetir en la lista de ejecuciones para medir las mismas páginas otra vez.',

    profundidade: 'Profundidad de navegación',
    nivel: 'Nivel',
    paginas: 'Páginas',
    fatia: 'Porción',
    paginaInicial: 'Página de entrada',
    cliquesDeDistancia: { um: 'a {n} clic', outros: 'a {n} clics' },
    profundidadeNota:
      'La profundidad es el camino más corto desde la página de entrada. Las páginas a cuatro o más clics se rastrean con menos frecuencia y son más difíciles de alcanzar.',

    metodologia: 'Metodología',
    metodologiaCrawl:
      'Silent Puma rastreó {paginas} de {alvo} el {data}, siguiendo el alcance y los límites configurados para la ejecución #{run}. Cada página se pidió una vez y se midió tal como la entregó el servidor.',
    metodologiaFaixas:
      'Los rangos de título y descripción ({tituloMin}–{tituloMax} y {metaMin}–{metaMax} caracteres) son las ventanas que suelen mostrarse sin recorte en los resultados — Google no publica una longitud oficial. El umbral de {carga}s de respuesta es más estricto de lo que exigen los Core Web Vitals, a propósito: medimos la respuesta del servidor, no el Largest Contentful Paint.',
    metodologiaRender:
      'Las páginas que respondieron con estado 2xx pero entregaron ningún título, ningún H1 y ningún enlace interno se reportan como "no renderizaron". Apuntan a la infraestructura, no a contenido que falta, y no cuentan en la cuota de tu plan.',
    semIa:
      'Este informe no tiene las secciones Resumen y Prioridades porque no se generó ningún análisis de IA para esta ejecución. Esas secciones vienen de ahí.',

    duvidas: 'Dudas sobre este informe: {email}',
    confidencial: 'Confidencial · uso del cliente',
    recorte: 'Las {n} primeras de {total}. La lista completa está en el panel.',
    falhou: 'No fue posible cargar esta sección.',
    periodo: 'Período',
    canal: 'Canal',
    finalidade: 'Finalidad',
    rastreador: 'Rastreador',
    acesso: 'Acceso',
    regra: 'Regla en robots.txt',
    dominio: 'Dominio',
    termos: 'Términos',
    antes: 'Antes',
    agora: 'Ahora',
    pioresPaginas: 'Las {n} páginas con la nota más baja',
    plano: {
      gsc: 'Disponible en los planes Pro y Business, con Search Console conectado.',
      ga4: 'Disponible en los planes Pro y Business, con Google Analytics conectado.',
      gscGa4: 'Disponible en los planes Pro y Business, con Search Console y Google Analytics conectados.',
      youtube: 'Disponible en los planes Pro y Business, con YouTube Analytics conectado.'
    }
  },

  runAnalise: {
    titulo: 'Análisis de la ejecución n.º {id}',
    paginas: { um: '{n} página', outros: '{n} páginas' },
    baixarCsv: 'Descargar CSV',
    baixarPdf: 'Descargar informe PDF',
    score: 'Puntuación SEO',
    de100: 'de 100',
    variacao: '{sinal}{n} frente a la ejecución n.º {run}',
    paginasAnalisadas: 'Páginas analizadas',
    verTodas: 'Ver todas las páginas',
    puladasPeloRobots:
      '{n} no fueron rastreadas: el robots.txt del sitio lo prohíbe. Si no es intencional, es allí donde se permite.',
    bloqueado: {
      titulo: 'Este sitio no permitió el rastreo',
      comStatus:
        'La dirección inicial respondió {status}, así que no llegamos a ver el sitio. No hay puntuación ni diagnóstico en esta ejecución — lo que aparece abajo es solo lo que trajo la página de bloqueo.',
      semStatus:
        '{n} de {total} páginas fueron rechazadas, así que no quedó sitio para medir. Esta ejecución no tiene puntuación.',
      comoLiberar:
        'Si el sitio es suyo, permita el agente {agente} en su WAF o CDN y ejecute de nuevo. Si no lo es, no hay nada que hacer desde aquí — y eludir la protección no es algo que hagamos.'
    },
    problemas: 'Problemas encontrados',
    maiorParteEm: { um: '{n} problema en {area}', outros: '{n} problemas en {area}' },
    semProblemas: 'Ningún problema en las cinco áreas.',
    respostaMedia: 'Respuesta media',
    acimaDoLimite: { um: '{n} página lenta', outros: '{n} páginas lentas' },
    analiseIa: 'Análisis de IA',
    tokens: { um: '{n} TOKEN', outros: '{n} TOKENS' },
    verOtimizacoes: 'Ver optimizaciones',
    gerarOtimizacoes: 'Generar optimizaciones',
    semAnalise: 'Esta ejecución aún no tiene análisis de IA. Generarlo consume un crédito.',
    ondeEstaoAsPerdas: 'Dónde están las pérdidas',
    nenhumaPerda: 'Ninguna página con problemas en las áreas medidas.',
    perda: {
      semTitulo: 'Sin título',
      semDescricao: 'Sin meta description',
      semH1: 'Sin H1',
      semAlt: 'Imágenes sin alt',
      semCanonical: 'Sin canonical',
      linksQuebrados: 'Con enlaces rotos',
      lentas: 'Carga lenta',
      semLinkInterno: 'Sin enlace interno de salida',
      semViewport: 'Sin viewport'
    },
    canal: {
      views: 'Visualizaciones totales',
      likes: 'Me gusta totales',
      comentarios: 'Comentarios por vídeo',
      engajamento: 'Tasa de interacción',
      semVariacao: 'Sin variación',
      varPct: '{sinal}{n}% frente a la ejecución n.º {run}',
      varPorVideo: '{sinal}{n} por vídeo frente a n.º {run}',
      varPontos: '{sinal}{n} p.p. frente a n.º {run}',
      videos: { um: '{n} vídeo', outros: '{n} vídeos' },
      tagsTitulo: 'Etiquetas con más interacción',
      tagsVazio:
        'Ninguna etiqueta aparece en dos vídeos o más — sin repetición no hay nada que comparar.',
      tagsNota:
        'Tasa agregada de los vídeos que llevan cada etiqueta, con la barra relativa a la primera. Solo entran etiquetas con dos vídeos o más.',
      medidas: 'Medidas del canal',
      comDescricao: 'Vídeos con descripción',
      descricaoInformativa: 'Descripción informativa',
      tituloNoLimite: 'Título dentro del límite',
      comThumbnail: 'Vídeos con miniatura',
      engajamentoBaixo: 'Vídeos con poca interacción',
      refMinimo: 'mínimo de {n} caracteres',
      refAte: 'hasta {n} caracteres',
      refAcima: 'por encima del {n}%',
      vazio: 'Esta ejecución no recopiló ningún vídeo.',
      rodapeRelatorio: 'Las etiquetas por interacción y la metodología están en el',
      rodape: 'Cada vídeo, con filtro y orden, está en',
      verVideos: 'todos los vídeos'
    },
    metricasTecnicas: 'Métricas técnicas',
    rodape: 'Las otras nueve medidas técnicas están en el',
    rodapeLink: 'informe completo'
  },

  canal: {
    titulo: 'Rendimiento del canal',
    intro: 'Lo que la API pública no cuenta: de qué búsqueda vino el tráfico y cuánto del video se vio. Ventana de 28 días, cerrada hace 4 días para que YouTube consolide.',
    naoConectado: 'Esta ejecución no tiene lectura de rendimiento. Conecta YouTube Analytics en las integraciones del proyecto y vuelve a ejecutar.',
    retencao: 'Retención media',
    retencaoAjuda: 'Cuánto del video se vio en promedio, ponderado por las views — un video con 4 views no pesa lo mismo que uno con 40.000. Es lo más cercano al CTR de miniatura que ofrece la API: impresión y CTR son medidas de YouTube Studio y no existen aquí.',
    tempoAssistido: 'Minutos vistos',
    tempoAssistidoAjuda: 'Suma del tiempo visto en la ventana. Pesa más en la recomendación de YouTube que el número de views.',
    inscritos: 'Suscriptores del período',
    inscritosAjuda: 'Ganados menos perdidos, sumando los videos con lectura. Separa el video que atrae del video que convierte.',
    termos: 'Términos de búsqueda',
    teto: 'La API de YouTube devuelve como máximo {teto} términos por consulta, y no hay paginación. La lista de abajo es el tope por views — no es la lista completa.',
    tituloTermos: 'Lo que escribieron para llegar',
    termosDoCanal: 'La API rechazó el filtro por video en esta lectura, así que los términos son del canal entero y no de un video específico.',
    semTermos: 'Ningún término de búsqueda en la ventana.',
    tituloVideos: 'Retención por video',
    semVideos: 'Ningún video con lectura de rendimiento en la ventana.',
    termo: 'Término',
    video: 'Video',
    views: 'Views',
    minutos: 'Minutos',
    retencaoCurta: 'Retención',
    duracaoMedia: 'Duración media',
    inscritosCurto: 'Suscriptores'
  },

  intencao: {
    titulo: 'Intención de búsqueda',
    intro: 'Lo que Google muestra en el top 10 de cada término, agrupado por lo que la persona quiere, y si tu página es del tipo correcto.',
    ler: 'Leer intención con IA (1 crédito)',
    lerDeNovo: 'Leer de nuevo (1 crédito)',
    lendo: 'Leyendo…',
    naoLido: 'Aún no leída en esta ejecución. Usa el top 10 de Google que la ejecución ya guardó.',
    indisponivel: 'Esta ejecución no guardó el top 10 de Google. Las próximas ejecuciones con Search Console lo guardan.',
    nota: 'La IA solo agrupa los resultados y juzga el tipo de tu página; los porcentajes se cuentan sobre el top 10. Es una foto del móvil en el momento de la ejecución.',
    termo: 'Término',
    googleMostra: 'Google muestra',
    suaPagina: 'Tu página',
    fatia: '{pct}% · {forma}',
    posicao: '{pos}º',
    foraDoTopo: 'fuera del top 10',
    encaixe: {
      sim: 'tipo correcto',
      parcial: 'en parte',
      nao: 'tipo equivocado',
      sem_pagina: 'sin página'
    }
  },
  canibalizacao: {
    titulo: 'Páginas que compiten por el mismo término',
    intro: 'Términos en los que Google reparte las impresiones entre páginas de tu sitio, medido en Search Console.',
    resumo: '{n} términos en disputa.',
    risco: 'Cerca de {cliques} clics en riesgo.',
    semDados: 'Sin datos de Search Console en las páginas rastreadas, así que no hay cómo ver competencia entre ellas.',
    nenhum: 'Ningún término con dos páginas compitiendo de verdad. Cada término con demanda tiene una página que responde por él.',
    acao: 'Si las páginas atienden la misma búsqueda, junta el contenido en la principal y redirige la otra (301). Si atienden búsquedas distintas — una categoría y un producto, por ejemplo —, mantén las dos y deja claro cuál responde por el término: título, enlace interno y canónica apuntando a ella.',
    estimativa: 'Clics en riesgo: lo que las otras páginas rendirían si sus impresiones fueran a la principal, con el CTR que tu sitio obtiene en su posición. Es una estimación, y queda en blanco cuando el sitio no tiene muestra en esa posición. Los términos con el nombre de la marca quedan fuera: ahí Google muestra varias páginas del sitio a propósito.',
    termo: 'Término',
    paginas: 'Páginas',
    principal: 'principal',
    detalhe: '{imp} impr. · pos. {pos}',
    impressoes: 'Impresiones',
    cliques: 'Clics',
    emRisco: 'Clics en riesgo',
    erro: 'No se pudieron cargar las páginas en competencia.'
  },
  oportunidades: {
    avaliar: 'Evaluar relevancia con IA (1 crédito)',
    avaliando: 'Evaluando…',
    reavaliar: 'Evaluar de nuevo (1 crédito)',
    relevancia: '¿La página lo merece?',
    rel: {
      alta: 'sí, falta ajuste',
      media: 'en parte',
      baixa: 'no es esta página'
    },
    alvo: 'La ganancia por posición se estima contra la posición {alvo}.',
    semTopo: 'Fuera de los términos con el nombre de tu marca, el sitio no aparece en las primeras posiciones para ninguna búsqueda con demanda relevante — la medición solo empieza en la {alvo}. Por eso la ganancia por posición se estima contra ella y no contra el tope: es la mejor posición que el sitio alcanza hoy.',
    foraMarca: '{n} términos con el nombre “{marca}” quedaron fuera: buscar la propia marca no es una oportunidad, y su CTR es demasiado alto para servir de referencia a los demás.',
    foraCanibal: '{n} pares quedaron fuera por disputar un término ya contado en otra página. El clic no vendría dos veces — pero dos páginas en el mismo término es un problema en sí.',
    titulo: 'Oportunidades',
    intro: 'Ganancia en clics según la curva de CTR del propio sitio.',
    semCurva: 'Todavía no hay búsquedas suficientes en las páginas rastreadas para medir cuánto convierte tu sitio en cada posición. Sin esa curva, cualquier estimación de ganancia sería una suposición.',
    estimativa: 'Las ganancias son una estimación, no un pronóstico. Salen del CTR que tu propio sitio obtiene en cada posición, y la ganancia por posición se calcula de forma conservadora — manteniendo las impresiones actuales, que en la práctica aumentan cuando la página sube.',
    verCurva: 'Ver la curva de CTR del sitio',
    ocultarCurva: 'Ocultar la curva',
    ctrMedido: 'CTR medido',
    nenhuma: 'Ningún par con ganancia estimada relevante. Es buena señal: lo que tiene demanda ya convierte cerca de lo que el sitio suele convertir.',
    termo: 'Término',
    pagina: 'Página',
    acao: 'Acción',
    acaoTexto: 'Reescribir título y descripción',
    acaoConteudo: 'Trabajar contenido y enlaces',
    posicao: 'Posición',
    impressoes: 'Impresiones',
    ctrAtual: 'CTR',
    ganho: 'Ganancia est.',
    resumo: '+{ganho} clics por ganar en {n} pares de página y término.'
  },

  integracoes: {
    titulo: 'Integraciones',
    chamada:
      'Conecta Google Analytics, Search Console y YouTube Analytics para cruzar el rendimiento con lo rastreado.',
    naoConectado: 'No conectado',
    ativo: 'activo',
    faltaEscolher: 'falta elegir la propiedad',
    conectadoEm: 'Conectado el {data}',
    conectar: 'Conectar',
    escolherPropriedade: 'Elegir propiedad',
    trocarPropriedade: 'Cambiar propiedad',
    desconectar: 'Desconectar',
    semPropriedades:
      'La cuenta conectada no tiene ninguna propiedad disponible para este servicio.',
    confirmarDesconexao:
      '¿Desconectar {nome} de este proyecto? El acceso se revoca en Google y la propiedad elegida se pierde.',
    retornoOk:
      'Cuenta conectada. Falta elegir qué propiedad pertenece a este proyecto — sin ella no hay nada que consultar.',
    retornoErro: 'No se pudo completar la conexión con Google. Inténtelo de nuevo.',
    nota: 'Solo lectura: los permisos que pedimos son de lectura. Nada se escribe en su cuenta de Google, y la conexión puede revocarse aquí en cualquier momento.',
    faltaEscolherCanal: 'falta elegir el canal',
    escolherCanal: 'Elegir canal',
    trocarCanal: 'Cambiar canal',
    semCanais: 'La cuenta conectada no administra ningún canal de YouTube.',
    retornoOkCanal: 'Cuenta conectada. Falta elegir qué canal pertenece a este proyecto — sin él, no hay nada que consultar.',
    canalDivergente: 'El canal conectado no es el que rastreó esta ejecución, así que no se leyó el rendimiento. Elige el canal correcto y vuelve a ejecutar.'
  },

  trafego: {
    ctr: 'CTR',
    rejeicao: 'Rebote',
    periodo: 'Search Console y Analytics · {periodo} · {dias} días, la ventana que midió esta ejecución',
    cobertura: {
      titulo: 'Cruce con el crawler',
      nota: 'Revísalo antes de los números: si las URLs no coinciden, un cero abajo parece medición y no lo es.'
    },
    tom: { ok: 'bueno', warn: 'atención', crit: 'malo' },
    faixa: { ok: 'top 10', warn: 'página 2', crit: 'después de la página 2' },
    gsc: {
      rotulo: 'Antes del clic · Search Console',
      titulo: 'Cómo se encuentra el sitio',
      leituraTitulo: 'Aparece y no convence',
      leituraNota: '100+ impresiones y CTR debajo de 1%: el problema está en el título y la descripción.',
      leituraMedida: '{impressoes} · {ctr}%'
    },
    ga: {
      rotulo: 'Después del clic · Analytics',
      titulo: 'Qué hace la visita',
      medias: 'Rebote medio de {rejeicao}, {engajamento} de interacción y {paginas} páginas por sesión. En GA4, el rebote es el inverso de las sesiones con interacción.',
      leituraTitulo: 'Recibe y rebota',
      leituraNota: '20+ sesiones y rebote de 70% o más: el problema está después del clic.',
      leituraMedida: '{sessoes} · {rejeicao}%',
      maior: 'La de mayor rebote con 20+ sesiones queda en {pct}%.'
    },
    vazio: 'Ninguna página en esta ejecución.',
    naoMedido:
      'Esta ejecución no midió búsqueda ni tráfico. Conecte Google Analytics y Search Console al proyecto — las próximas ejecuciones traerán el cruce.',
    conectar: 'Configurar integraciones',
    casamento: 'Coincidencia',
    casamentoNota: '{casadas} de {total} páginas rastreadas tienen datos de Google',
    completude: 'Completitud',
    completudeNota: '{casadas} de {total} URLs de Google fueron rastreadas.',
    orfasEm: 'Las otras {n} están en Técnico.',
    cliques: 'Clics',
    impressoes: 'Impresiones',
    sessoes: 'Sesiones',
    usuarios: 'Usuarios',
    engajadas: 'Con interacción',
    somadosPorEntrada: 'sumados por página de entrada',
    conversoes: 'Conversiones',
    porEntrada: 'por página de entrada',
    porEvento: 'en la página del evento',
    posicao: 'Posición',
    posicaoMedia: 'Posición media',
    pagina: 'Página',
    paginasTitulo: 'Rendimiento por página',
    tabelaNota: 'En el orden del embudo: aparece, recibe clic, retiene, convierte.',
    tabelaLink: 'Para filtrar y exportar, usa la pestaña Páginas.',
    porDia: {
      titulo: 'Clics y sesiones por día',
      nota: 'El sitio entero, día a día. Pasa el mouse o toca una barra para leer el día.',
      serie: '{serie} · {total} en el período · pico de {pico} el {dia}',
      dia: 'Día'
    },
    porCanal: {
      titulo: 'Sesiones por canal',
      nota: '{total} sesiones en el sitio entero, cada una contada una vez, por el origen que GA4 asignó. Las Sesiones de arriba suman las páginas: allí, quien ve tres páginas cuenta tres veces.'
    },
    /* Los nombres que GA4 da a los canales, como el propio GA4 los traduce. */
    canal: {
      'Organic Search': 'Búsqueda orgánica',
      'Paid Search': 'Búsqueda de pago',
      Direct: 'Directo',
      'Cross-network': 'Red cruzada',
      'Organic Shopping': 'Shopping orgánico',
      'Paid Shopping': 'Shopping de pago',
      'Organic Social': 'Social orgánico',
      'Paid Social': 'Social de pago',
      'Organic Video': 'Vídeo orgánico',
      'Paid Video': 'Vídeo de pago',
      'Paid Other': 'Otros de pago',
      Display: 'Display',
      Referral: 'Referencia',
      Email: 'Correo electrónico',
      Affiliates: 'Afiliados',
      SMS: 'SMS',
      Audio: 'Audio',
      'Mobile Push Notifications': 'Notificaciones push',
      'AI Assistant': 'Asistente de IA',
      Unassigned: 'Sin asignar'
    },
    orfasTitulo: '{n} URLs que Google conoce y el rastreo no visitó',
    orfasNota: '{verificadas} verificadas por solicitud HTTP; {faltam} esperan verificación.',
    recuperacaoTitulo: 'Una regla puede recuperar parte',
    recuperacaoMedida:
      'Probada en {testadas} URLs, funcionó en {recuperadas} ({acerto}%). Estimación: {estimadas} de las {afetadas} afectadas volverían.',
    recuperacaoParcial:
      'No aplique la regla sin verificar el destino: la parte que no recupera caería en la misma página de error que se quiere eliminar. El redirect debe devolver 404 para lo que no exista.',
    classe: { soft404: 'soft 404', morta: 'muerta', redirecionada: 'redirigida', viva: 'viva', bloqueada_robots: 'bloqueada por robots' },
    acao: { soft404: 'Responden 200 con una página de error. Redirigir al equivalente o devolver 404/410.', morta: 'Comportamiento correcto: Google las elimina con el tiempo. Redirigir con 301 solo si hay equivalente.', redirecionada: 'Actualizar enlaces internos y el sitemap al destino final.', viva: 'Funcionan y el crawler no llegó a ellas: falta un enlace interno o el tope de páginas las cortó.', bloqueada_robots: 'El robots.txt cierra esa área y no las verificamos: confirmar que el bloqueo es intencional.' },
    orfasNotaTodas: 'Las {verificadas} verificadas por solicitud HTTP.',
    col: { estado: 'Estado', urls: 'URLs', fazer: 'Qué hacer' }
  },

  social: {
    titulo: 'Redes sociales',
    resumo: '{sessoes} sesiones · {conversoes}',
    conversoes: { um: '{n} conversión', outros: '{n} conversiones' },
    naoColetado:
      'Esta ejecución no leyó el tráfico de redes sociales. Las ejecuciones sin Google Analytics, o anteriores a esta medición, no tienen el dato.',
    vazio: 'Ninguna visita desde redes sociales en el período.',
    organico: 'Orgánico',
    pago: 'Pago',
    nota: 'Según la clasificación de canales de Google Analytics. Un enlace abierto desde WhatsApp a menudo llega sin origen y aparece como tráfico directo, no social.',
    col: {
      rede: 'Red',
      canal: 'Tipo',
      sessoes: 'Sesiones',
      engajamento: 'Con interacción',
      conversoes: 'Conversiones',
      paginas: 'Páginas de entrada'
    }
  },

  serp: {
    titulo: 'Quién aparece contigo',
    intro: 'Dominios en el top 10 del celular, entre los {n} términos medidos',
    naoMedido:
      'Esta ejecución no leyó la página de Google. La lectura necesita Search Console conectado y el volumen de búsqueda.',
    falhou: 'no llegó',
    foraDoTopo: 'fuera del top 10',
    bloco: {
      paid: 'Anuncios',
      ai_overview: 'AI Overview',
      featured_snippet: 'Fragmento destacado',
      answer_box: 'Respuesta directa',
      popular_products: 'Productos',
      shopping: 'Shopping',
      local_pack: 'Mapa con empresas',
      map: 'Mapa',
      people_also_ask: 'Preguntas relacionadas',
      images: 'Imágenes',
      video: 'Videos',
      short_videos: 'Videos cortos',
      top_stories: 'Noticias',
      knowledge_graph: 'Panel de conocimiento',
      discussions_and_forums: 'Foros'
    },
    nota: 'La barra cuenta en cuántos de los {n} términos el dominio aparece en el top 10. Es el retrato del día de la ejecución; la posición y los bloques de cada término están en la tabla de arriba.',
    acima: '{bloco} aparece arriba del sitio en {n} de los {m} términos en que está en el top 10.',
    acimaUm: '{bloco} aparece arriba del sitio en el único término en que está en el top 10.',
    semConcorrentes: 'Ningún dominio en el top 10 de esos términos.'
  },
  comparacao: {
    titulo: 'Desde la ejecución anterior',
    intro: 'Frente a la ejecución {nome}, del {data}, en las {n} páginas que ambas midieron.',
    introRerun: 'Re-run de la ejecución {nome}, del {data}: las mismas {n} páginas, medidas de nuevo.',
    foraDaConta: '{atual} páginas solo en esta ejecución y {base} solo en la anterior quedan fuera de la cuenta.',
    corte:
      'Una de las dos se detuvo en el límite de páginas: la comparación vale para las páginas en común, no para todo el sitio.',
    semBase: 'Aún no hay una ejecución anterior completada de este proyecto para comparar.',
    semMudanca: 'Ningún problema cambió en las páginas en común.',
    col: { problema: 'Problema', corrigidas: 'Corregidas', novas: 'Nuevas' },
    nota:
      'Una página cuenta como corregida cuando tenía el problema en la anterior y no en esta, y como nueva en el caso inverso. Los filtros de la pantalla no se aplican aquí. Los sitios que cambian el contenido en cada visita pueden mostrar cambios aunque nada se haya editado.'
  },
  tendencias: {
    titulo: 'Tendencias',
    naoMedido:
      'Esta ejecución no comparó los términos. Las ejecuciones sin Search Console, o hechas antes de esta medición, no tienen el dato.',
    emAlta: 'En alza',
    novos: 'Nuevos',
    emQueda: 'En caída',
    vazio: 'Ningún término.',
    nota: 'Solo entran términos con al menos 30 impresiones en una de las dos ventanas. Google omite las búsquedas raras, así que un término nuevo puede haber existido por debajo de ese límite. Cuando todo el sitio crece, casi todo término sube con él: compare cada variación con la del total.',
    sub: 'Impresiones en esta ventana, contra los 28 días anteriores'
  },

  velocidade: {
    titulo: 'Velocidad de las páginas',
    naoMedido:
      'Esta ejecución no midió la velocidad de las páginas. Las ejecuciones hechas antes de esta medición no tienen el dato.',
    medindo:
      'Midiendo la velocidad de las páginas principales en Google. Tarda unos minutos después del fin del rastreo, y esta sección se actualiza sola.',
    medindoCsv:
      'La velocidad todavía se está midiendo en Google. El CSV descargado ahora sale sin PageSpeed, LCP, INP y CLS; en unos minutos este aviso desaparece y el archivo sale completo.',
    naoMedida: 'Google no pudo medir esta página.',
    tom: {
      bom: 'bueno',
      medio: 'necesita mejorar',
      ruim: 'malo'
    },
    nota: 'Notas: menos de 50 es malo, de 50 a 89 necesita mejorar, 90 o más es bueno. "dominio": la página no tiene visitas suficientes para tener datos de campo propios, y vale el de la tarjeta de arriba.',
    col: {
      pagina: 'Página',
      nota: 'Nota',
      lcp: 'LCP',
      inp: 'INP',
      cls: 'CLS',
      resposta: 'Respuesta del HTML',
      peso: 'Peso del HTML'
    },
    fontes: 'Crawler: todas las páginas, en el momento de la ejecución · PageSpeed: {n} páginas con más visitas, celular',
    frase: { lab: 'El laboratorio da {media}.', labHtmlRapido: 'El laboratorio da {media}, y el HTML no es lo que pesa.', labHtmlLento: 'El laboratorio da {media}, y el HTML tarda {ms} ms en promedio.' },
    rotulo: { resposta: 'Respuesta del HTML', lab: 'Nota de laboratorio', campo: '{m} · campo' },
    notaResposta: 'promedio de {n} páginas · crawler',
    mediaDe: 'promedio de {n} páginas',
    limiteDe: 'límite {valor}',
    dominio: { titulo: 'Core Web Vitals del dominio', sub: 'Visitantes reales de Chrome, 28 días. {k} de las {n} páginas no tienen datos propios y reciben los del dominio.', subTodas: 'Visitantes reales de Chrome, 28 días.', lcp: 'LCP · mayor elemento visible', inp: 'INP · respuesta a clic y toque', cls: 'CLS · desplazamiento del diseño', regua: '{m} {valor}, en la franja {faixa}; el límite de bueno es {limite}', propria: '{pagina} tiene datos propios: LCP {lcp}, INP {inp}, CLS {cls}.', home: 'La home' },
    html: { titulo: 'Tiempo de respuesta del HTML', sub: 'Medido por el crawler en las {n} páginas.', leituraTitulo: 'Lectura cruzada', leitura: '{a} responde en {msA} y obtiene {notaA}. {b} responde en {msB} y obtiene {notaB}. La nota baja viene de lo que carga después del HTML: scripts, imágenes, fuentes.' },
    tabela: { titulo: 'Las {n} páginas medidas', sub: 'Nota de laboratorio, mediana de 3 mediciones; la de una página varía unos 10 puntos entre ejecuciones, el promedio del sitio no. Respuesta y peso vienen del crawler.', dominio: 'dominio' }
  },
  termosPrincipais: {
    titulo: 'Términos principales, una fila cada uno',
    intro:
      'Los {n} términos con más impresiones en Brasil, con lo que midió Search Console, la posición en el celular durante la ejecución y la demanda en Google Ads.',
    grupo: {
      gsc: 'Search Console · 28 días',
      serp: 'Celular · en la ejecución',
      ads: 'Google Ads'
    },
    col: {
      termo: 'Término',
      impressoes: 'Impresiones',
      variacao: 'Variación',
      cliques: 'Clics',
      posicao: 'Posición',
      celular: 'Celular hoy',
      volume: 'Búsquedas/mes',
      captura: 'Captura',
      meses: '12 meses',
      cpc: 'CPC (US$)'
    },
    blocos: { um: '{n} bloque arriba', outros: '{n} bloques arriba' },
    serie: '12 meses: de {de} a {ate} búsquedas por mes',
    concorrencia: {
      LOW: 'baja',
      MEDIUM: 'media',
      HIGH: 'alta'
    },
    nota:
      'Variación de impresiones contra los 28 días anteriores; compárela con la del sitio completo en Tendencias. La posición de Search Console es el promedio de 28 días y de todos los dispositivos; "Celular hoy" es el retrato de una búsqueda en el momento de la ejecución. CPC y competencia de Google Ads, vía DataForSEO.'
  },
  historico: {
    titulo: 'Entre ejecuciones',
    col: {
      execucao: 'Ejecución',
      nota: 'Nota',
      cliques: 'Clics'
    }
  },

  termos: {
    titulo: 'Términos de búsqueda',
    intro:
      'Para qué búsquedas aparece cada página: un par de página y término por fila.',
    naoColetado:
      'Esta ejecución no recopiló términos de búsqueda. Las ejecuciones anteriores a esta medición no tienen el dato.',
    truncado:
      'La recopilación alcanzó el tope por ejecución. Estos son los términos más clicados, no todos — el resto quedó fuera.',
    recorte: 'Recorte de la lista',
    recorteAtaque: 'A distancia de ataque',
    recorteTodos: 'Todos',
    mostrando: 'Mostrando {n} términos a distancia de ataque, de {total} en total.',
    vazio: 'Ningún término de búsqueda en esta ejecución.',
    vazioAtaque:
      'Ningún término a distancia de ataque en esta ejecución. Elija “Todos” para ver la lista completa.',
    anonimizacao:
      'Google no informa consultas de bajo volumen. Por eso la suma de impresiones por término es siempre menor que el total de la página — no es un fallo de la recopilación.',
    volumeNota:
      'Búsquedas en Brasil en {mes}, en los rangos redondeados que informa Google Ads (vía DataForSEO). La captura es la parte de esas búsquedas en la que apareció el sitio: impresiones en Brasil ÷ búsquedas del mes. Un guion indica que Google no tiene el dato o que el término tuvo menos de 10 impresiones.',
    col: {
      termo: 'Término',
      pagina: 'Página',
      impressoes: 'Impresiones',
      cliques: 'Clics',
      ctr: 'CTR',
      posicao: 'Posición',
      volume: 'Búsquedas/mes',
      captura: 'Captura'
    }
  },

  botsIa: {
    titulo: 'Bots de IA en robots.txt',
    intro:
      'Lo que el robots.txt del sitio permite a los buscadores de IA. Un sitio puede estar impecable y aun así estar cerrado para ellos.',
    indisponivel:
      'No fue posible leer el robots.txt del sitio en esta ejecución. Sin él no se puede afirmar qué está permitido.',
    erro: 'Esta ejecución no verificó el robots.txt.',
    aviso: '{n} rastreador(es) de IA sin acceso al sitio: {nomes}.',
    resposta: 'Leen para responder ahora',
    treino: 'Leen para entrenar modelos',
    semJuizo:
      'Bloquear puede ser la decisión correcta — no recomendamos nada aquí, solo mostramos el estado. Lo que no conviene es que el bloqueo exista sin que nadie lo sepa.',
    estado: {
      livre: 'Permitido',
      restrito: 'Parcial',
      bloqueado: 'Bloqueado'
    },
    contagem: { restrito: { um: '{n} parcial', outros: '{n} parciales' }, bloqueado: { um: '{n} bloqueado', outros: '{n} bloqueados' } },
    todosLivres: 'todos permitidos'
  },

  docs: {
    titulo: 'Documentación',
    chamada: 'Cómo funciona Silent Puma, descrito a partir de lo que el producto hace de verdad.',
    indice: 'Secciones',

    comecarTitulo: 'Primeros pasos',
    comecarA:
      'Un proyecto es un sitio web o un canal de YouTube. Dentro de él, cada ejecución es un rastreo: una foto de ese sitio ese día. Puedes tener {projetos} proyecto(s) en el plan {plano}.',
    comecarB:
      'El orden es siempre el mismo — crear el proyecto, configurar la ejecución, esperar a que termine y entonces leer el panel. Nada se analiza antes de que la ejecución concluya, porque un rastreo a medias produce una foto a medias, y no hay forma de saber qué mitad falta.',

    rastreamentoTitulo: 'Configurar un rastreo',
    rastreamentoA:
      'El comportamiento decide hasta dónde llega el rastreador: seguir todo enlace del dominio, quedarse bajo la ruta inicial, o incluir subdominios. Los subdominios cuentan en la misma cuota de páginas, así que es la opción que más mueve tu consumo.',
    rastreamentoB:
      'Los parámetros de URL son el otro ajuste que mueve el número. Mantenerlos hace que cada combinación de filtro sea una página distinta — en una tienda con color y talla, un solo producto consume decenas. Descartarlos rastrea cada página una vez.',
    rastreamentoC:
      'Antes de empezar, usa "Estimar páginas coincidentes". Lee el sitemap del sitio y muestra cuántas direcciones coinciden con tus filtros, con ejemplos. Los ejemplos son el punto: es ahí donde notas que "/p" también atrapó la política de privacidad.',

    painelTitulo: 'Leer el panel',
    painelA:
      'El panel se divide en cinco áreas, en el orden en que el problema importa: indexación, contenido, experiencia, medios y enlaces. Si el rastreador no llega a la página, nada más sobre ella importa — por eso la indexación va primero.',
    painelB:
      'El número en cada pestaña es cuántas páginas tienen un problema en esa área, no cuántos problemas hay. Una página sin título y sin H1 cuenta una vez. La pestaña con una marca significa que ahí no hay nada que corregir, así que puedes saltarla sin abrirla.',
    painelC:
      'Los títulos se miden contra {tituloMin}–{tituloMax} caracteres y las descripciones contra {metaMin}–{metaMax}. Google no publica una longitud oficial; esos son los rangos que suelen mostrarse sin recorte. Un tiempo de respuesta superior a {lenta}s se marca como lento — medimos la respuesta del servidor, no el Largest Contentful Paint.',

    iaTitulo: 'Análisis de IA',
    iaA: 'La IA lee los datos del rastreo y devuelve una lista priorizada de correcciones, cada una indicando a cuántas páginas afecta. Nunca se ejecuta sola: generar cuesta créditos, así que solo ocurre cuando lo pides. Tu plan incluye {creditos} créditos al mes.',
    iaB: 'El análisis estándar cuesta un crédito y el profundo cuesta dos. El profundo dedica más razonamiento a sitios complejos; en una revisión de rutina la diferencia rara vez se nota. El campo de enfoque es el control que vale la pena usar — eres tú quien sabe que el blog no importa, o que el catálogo es la prioridad.',
    iaC: 'Cada generación se guarda como una versión, así que puedes comparar dos configuraciones sin pagar dos veces. El análisis se escribe en el idioma de tu cuenta, que defines en tu perfil.',

    conectorTitulo: 'Conector para tu IA',
    conectorA:
      'El conector abre los datos de tus rastreos dentro de la IA que ya usas — Claude, ChatGPT o Cursor. En lugar de leer el informe aquí, preguntas allá, con el modelo y el contexto que ya son tuyos.',
    conectorB:
      'Por defecto solo lee, y leer no consume créditos ni cuota, porque la inteligencia es tuya. Si quieres, en Configuración puedes permitir que la IA solicite rastreos: cada uno consume la cuota de páginas de tu plan, con un tope diario y uno a la vez por proyecto. Aun así, ninguna herramienta crea proyectos, borra ejecuciones, genera análisis ni modifica tu cuenta.',
    conectorC:
      'Preguntas que responde bien: qué páginas tienen enlaces rotos, para qué términos aparece cada página, qué recomendó priorizar el último análisis, cuánto de tu plan has usado, y qué vídeos del canal tienen más visualizaciones.',
    conectorD:
      'Cuando publicamos herramientas nuevas no aparecen solas: tu IA guarda la lista de cuando conectaste. Quita el conector y añádelo de nuevo para verlas.',
    conectorPasso1: 'Copia la dirección de arriba.',
    conectorPasso2:
      'En tu IA, abre la configuración de conectores y elige añadir un conector personalizado. En algunas aplicaciones la opción aparece como "MCP".',
    conectorPasso3:
      'Pega la dirección y confirma. Volverás a Silent Puma para iniciar sesión y autorizar el acceso.',
    conectorPasso4:
      'Listo. Vuelve a la conversación y pregunta sobre tus proyectos — la IA buscará los datos por su cuenta cuando lo necesite.',

    relatorioTitulo: 'El informe en PDF',
    relatorioA:
      'Toda ejecución completada puede convertirse en un informe de auditoría técnica, hecho para entregar al cliente. Se abre como página y se imprime desde el navegador, lo que produce texto vectorial de verdad — buscable y nítido a cualquier zoom, a diferencia de una exportación en imagen.',
    relatorioB:
      'El informe trae un score de SEO de 0 a 100. Parte de 100 y pierde una parte del peso de cada área en proporción a las páginas afectadas: indexación 25, contenido 30, experiencia 20, enlaces 15, medios 10. Una página con tres problemas en la misma área cuenta una vez — es una página que corregir, no tres.',
    relatorioC:
      'Cuando existe análisis de IA, el informe abre con su resumen y sus prioridades. Sin él el informe sale igual, solo que sin esas dos secciones.',

    repetirTitulo: 'Repetir una ejecución',
    repetirA:
      'Dos ejecuciones del mismo sitio rara vez cubren las mismas páginas: cada una descubre direcciones a partir de la URL inicial, así que un enlace que apareció esta semana cambia la muestra. Comparar el score entre muestras distintas mide la muestra, no el sitio.',
    repetirB:
      '"Repetir", en la lista de ejecuciones, rastrea exactamente las páginas que recogió la ejecución anterior. Eso es lo que hace que la diferencia de score signifique algo — y el informe dice en cuál de las dos situaciones estás.',

    planosTitulo: 'Planes y límites',
    planosA:
      'Tu plan define tres cosas: cuántos proyectos puedes tener ({projetos}), cuántas páginas puedes rastrear al mes ({paginas}) y cuánto tiempo se guardan los datos recogidos ({retencao} días). El mes se reinicia en tu fecha de facturación.',
    planosB:
      'Las páginas que respondieron con estado de éxito pero no entregaron contenido útil no cuentan en la cuota. No recibiste ningún dato de ellas, y todavía tendrás el trabajo de averiguar por qué — cobrar cuota encima de eso sería cobrar por algo que no se entregó.',

    dadosTitulo: 'Tus datos',
    dadosA:
      'El rastreo recoge lo que la página publica: dirección, estado, título, descripción, encabezados, enlaces y recuento de imágenes. Nada detrás de un inicio de sesión, y ninguna página que el sitio pida no indexar.',
    dadosB:
      'Cuando pides un análisis de IA, métricas agregadas y una muestra de direcciones van al proveedor de IA — nunca los datos de tu cuenta ni tus credenciales. La política de privacidad lo describe campo por campo.',

    duvidaTitulo: '¿Sigues atascado?',
    duvidaTexto:
      'Escribe a {email} contando qué estabas haciendo y qué esperabas. Mencionar el número de la ejecución ayuda — es lo que nos deja mirar exactamente el dato que tú estabas mirando.'
  },

  blog: {
    eyebrow: 'Blog',
    titulo: 'Qué medimos, y qué quieren decir los números',
    chamada:
      'Notas técnicas de quienes ejecutan rastreadores todos los días. Cada post trae el método, para que compruebes en vez de creer.',
    buscar: 'Buscar en el blog',
    emDestaque: 'Destacado',
    todosOsPosts: 'Todos los posts',
    publicados: { um: '{n} PUBLICADO', outros: '{n} PUBLICADOS' },
    minutos: { um: '{n} min de lectura', outros: '{n} min de lectura' },
    semPosts: 'Todavía no hay nada publicado. Las primeras notas se están escribiendo.',
    semResultado: 'Ningún post coincide con esta búsqueda.',
    voltar: '← Volver al blog',
    nestePost: 'En este post',
    leiaTambem: 'Lee también',
    catProduto: 'Producto',
    catMetodo: 'Método',
    catYoutube: 'YouTube'
  },

  erros: {
    oportunidades: 'No se pudieron cargar las oportunidades.',
    desempenhoCanal: 'No se pudo cargar el rendimiento del canal.',
    perfil: 'No se pudo guardar tu perfil.',
    empresa: 'No se pudieron guardar los datos de la empresa.',
    convite: 'No se pudo enviar la invitación.',
    equipe: 'No se pudo cambiar el equipo.',
    foto: 'Error al actualizar la foto de perfil.',
    uso: 'Error al cargar los datos de uso',
    checkout: 'Error al crear la sesión de pago',
    compra: 'No se pudo iniciar la compra.',
    cancelamento: 'Error al cancelar la suscripción.',
    exclusao: 'Error al eliminar la cuenta.',
    mensagem: 'Error al enviar el mensaje',
    planoIndisponivel: 'Este plan no está disponible para compra en este momento.',
    integracao: 'No se pudo iniciar la integración.',
    integracaoRecursos: 'No se pudieron listar las propiedades de la cuenta conectada',
    projetos: 'Error al cargar los proyectos',
    apagarProjeto: 'Error al eliminar el proyecto',
    baixar: 'Error al descargar los resultados',
    acessoNegado: 'Acceso denegado a este proyecto',
    carregarProjeto: 'Error al cargar el proyecto',
    carregarExecucoes: 'Error al cargar las ejecuciones',
    trafego: 'Error al cargar búsqueda y tráfico',


    termos: 'Error al cargar los términos de búsqueda',
    social: 'Error al cargar el tráfico de redes sociales',
    velocidade: 'Error al cargar la velocidad de las páginas',
    tendencias: 'Error al cargar los términos en alza',
    comparacao: 'Error al cargar la comparación con la ejecución anterior',
    serp: 'Error al cargar la página de Google',
    execucao: 'Error al cargar la ejecución',
    repetir: 'No se pudo repetir la ejecución.',
    apagarExecucao: 'Error al eliminar la ejecución',
    pararExecucao: 'No se pudo detener la ejecución.',
    login: 'Fallo al entrar. Revisa tus datos.',
    loginFalha: 'Error al entrar. Intenta de nuevo más tarde.',
    conexao: 'Error de conexión. Intenta de nuevo.',
    emailUsado: 'El correo ya está registrado',
    cadastro: 'Error al procesar la solicitud.',
    recuperacao: 'No se pudo procesar la solicitud.',
    atualizarSenha: 'No se pudo actualizar la contraseña.',
    concluirCadastro: 'Error al completar el registro.',
    plano: 'Este plan no está disponible ahora.',
    requisicao: 'Error al procesar la solicitud.',
    generico: 'Algo salió mal. Intenta de nuevo más tarde.',
    cancelamentoAssinatura: 'No se pudo cancelar la suscripción.',
    historico: 'Error al cargar el historial de cargos',
    configuracao: 'Error al cargar la configuración.',
    criarProjeto: 'Error al crear el proyecto.',
    criarProjetoTentar: 'Error al crear el proyecto. Intenta de nuevo.',
    nomeDaRun: 'Escribe un nombre para la ejecución.',
    semItens: 'Solo tienes {n} elementos disponibles en el plan {plano}.',
    iniciarCrawler: 'Error al iniciar el rastreo.',
    servidorInacessivel: 'No se pudo contactar con el servidor.',
    enviar: 'No se pudo enviar. Intenta de nuevo.',
    execucoes: 'Error al cargar las ejecuciones',
    dados: 'Error al cargar los datos',
    otimizacoes: 'No se pudieron generar las optimizaciones.',
    projeto: 'No se pudo cargar este proyecto.',
    execucoesDoProjeto: 'No se pudieron cargar las ejecuciones de este proyecto.',
    paginasColetadas: 'No se pudieron cargar las páginas recogidas.'
  },

  /* Área con sesión nueva (NewAppShell y las pantallas New*). */
  area: {
    navegacao: 'Navegación principal',
    caminho: 'Ruta',
    de: 'de {total}',
    semLimite: 'sin límite',
    limiteDoPlano: 'límite de {total} en el plan',
    creditosRestantes: '{restantes} de {total} créditos de IA disponibles',
    creditosDoMes: 'Del mes: {mes}',
    creditosOrigem: 'Del mes: {mes} · Comprados: {extra}',
    creditosCurto: 'créditos',
    privacidade: 'Privacidad',
    termos: 'Términos',
    hoje: 'hoy',
    ontem: 'ayer',
    dias: { um: 'hace {n} día', outros: 'hace {n} días' },
    meses: { um: 'hace {n} mes', outros: 'hace {n} meses' },
    anos: { um: 'hace {n} año', outros: 'hace {n} años' },
    painel: {
      resumo: 'Resumen de la cuenta',
      ultima: 'Última ejecución: #{id}, en {projeto}, {situacao}.',
      situacao: {
        completed: 'iniciada {quando}',
        in_progress: 'en curso',
        pending: 'en cola',
        error: 'falló',
        cancelled: 'cancelada'
      },
      paginasEVideos: 'Páginas y videos',
      paginasDetalhe: '{sites} de sitios · {videos} de YouTube',
      atalhos: 'Atajos',
      atalhoDocsTexto: 'Cómo se calcula la nota y cómo configurar un rastreo.'
    },
    integracoes: 'Integraciones',
    intervalo: '{de}–{ate} de {total}',
    projetos: {
      tipo: 'Tipo',
      itens: 'Páginas o videos',
      ultima: 'Última ejecución',
      paginas: { um: 'página', outros: 'páginas' },
      videos: { um: 'video', outros: 'videos' },
      execucoes: { um: 'ejecución', outros: 'ejecuciones' },
      semResultado: 'Ningún proyecto con ese nombre en este filtro.'
    },
    criar: {
      tipoTexto: 'Define la dirección pedida abajo y lo que recoge la ejecución: páginas o videos.',
      nomeTexto: 'Para encontrar el proyecto en la lista y en el panel.'
    },
    sim: 'Sí',
    nao: 'No',
    conta: {
      usoEm: 'Uso, créditos y cambio de plan están en',
      perfilTexto: 'El nombre y la foto aparecen en el menú. El correo es el del inicio de sesión.',
      trocarFoto: 'Cambiar foto',
      idiomaNaHora: 'Cambia al instante y queda guardado en la cuenta.'
    },
    plano: {
      uso: 'Uso de la cuenta',
      recurso: 'Recurso',
      seuPlano: 'tu plan',
      linhas: {
        preco: 'Precio',
        projetos: 'Proyectos',
        paginas: 'Páginas por mes',
        creditos: 'Créditos de IA por mes',
        painel: 'Panel del sitio y del canal',
        conector: 'Conector MCP para tu IA',
        integracoes: 'Analytics, Search Console y YouTube Analytics',
        suporte: 'Soporte',
        retencao: 'Retención de datos'
      },
      dias: { um: '{n} día', outros: '{n} días' },
      ultimaRenovacao: 'Créditos del mes renovados el {data}',
      ultimaCobranca: 'Último cobro',
      cobrancaFalhou: 'Este cobro no se completó. El historial muestra todos los cobros.',
      mensagemBusiness: 'Me interesa el plan Business.'
    },
    pagamentos: {
      verRecibo: 'Ver recibo',
      semRecibo: 'Sin recibo'
    },
    abas: {
      rotulo: 'Páginas del proyecto',
      painel: 'Panel',
      visao: 'Visión general',
      trafego: 'Búsqueda y tráfico',
      termos: 'Palabras clave',
      tecnico: 'Técnico',
      velocidade: 'Velocidad',
      paginas: 'Páginas'
    },
    palavras: {
      fonte: { gsc: 'Search Console, consultas en Brasil · {periodo}', volume: 'volumen de Google Ads de {mes}', serp: 'SERP en celular el {data}' },
      rotulo: { termos: 'Términos con impresión', ataque: 'En distancia de ataque', celular: 'En el top 10 del celular', impressoes: 'Impresiones en Brasil' },
      nota: { termos: 'pares página × término', celular: 'los {n} términos con más impresiones', impressoes: '{antes} → {agora}, contra los 28 días anteriores' },
      de: 'de {n}'
    },
    visao: {
      ctrPosicao: 'CTR {ctr}% · posición {posicao}',
      conversoes: { um: '{n} conversión', outros: '{n} conversiones' },
      ataque: 'posición 5 a 20, con demanda',
      velocidade: 'Nota de velocidad',
      naoMedido: 'no medido en esta ejecución',
      rotulo: { cliques: 'Clics de Google', ataque: 'Términos en ataque', cwv: 'Core Web Vitals' },
      critico: 'crítico',
      nenhum: 'ninguno',
      tipos: { um: 'en {n} tipo de problema', outros: 'en {n} tipos de problema' },
      engajadas: '{pct}% con interacción',
      de3: 'de 3 buenos',
      cwvNota: 'LCP {lcp} · INP {inp}',
      contexto: 'Ejecución #{id} · {data}',
      google: 'Google: {periodo}',
      frase: {
        paginas: '{n} páginas, {erro} con error.',
        google: 'En Google, {impressoes} impresiones se convirtieron en {cliques} clics.',
        cwvTodos: 'Los visitantes reales pasan los tres Core Web Vitals.',
        cwvParte: 'Los visitantes reales pasan {n} de 3 Core Web Vitals.'
      },
      blocos: { um: '{n} bloque', outros: '{n} bloques' },
      achados: { titulo: 'Un hallazgo por pestaña', sub: 'el mayor de cada tema en esta ejecución' },
      achado: {
        termo: '"{termo}" tiene {volume} búsquedas al mes y el sitio captura {captura}%.',
        celularPosicao: ' En el celular, está en {pos}º, con {blocos} arriba.',
        celularFora: ' En el celular, está fuera del top 10, con {blocos} en la página.',
        pagina: '{pagina} aparece {impressoes} veces en la posición {posicao} y recibe {cliques} clics (CTR {ctr}%).',
        orfas: '{soft} URLs que Google aún conoce responden como soft 404, y {mortas} están muertas.',
        velocidade: '{pagina} tiene nota {nota} en laboratorio, la menor de las {n} medidas.',
        problema: 'El problema crítico más frecuente es "{problema}", en {n} páginas.'
      },
      acao: { termo: 'Ver término', pagina: 'Ver página', urls: 'Ver URLs', lista: 'Abrir lista' },
      fontes: {
        titulo: 'Fuentes de esta ejecución',
        crawler: 'Crawler',
        gsc: 'Search Console',
        ga: 'Analytics',
        psi: 'PageSpeed',
        dfs: 'DataForSEO',
        robots: 'robots.txt',
        paginas: '{n} páginas',
        psiDetalhe: '{n} páginas, celular',
        volume: 'volumen de {mes}',
        bots: '{n} bots de IA',
        lido: 'leído',
        naoMedido: 'no medido',
        falhou: 'falló'
      },
      corrigidas: { um: '{n} corregida', outros: '{n} corregidas' },
      novas: { um: '{n} nueva', outros: '{n} nuevas' },
      saldo: 'Contra la #{base}, solo URLs en común: {corrigidas} y {novas}.',
      detalhe: 'Detalle en Técnico'
    },
    conjuntos: {
      rotulo: 'Conjunto de columnas',
      essencial: 'Esencial',
      tecnico: 'Técnico',
      trafego: 'Tráfico',
      conteudo: 'Contenido',
      produto: 'Producto',
      oQueMostra: 'Qué muestra cada conjunto'
    },
    runs: {
      repeteA: 'repite la #{n}'
    },
    nova: {
      titulo: 'Nueva ejecución',
      filtros: 'Filtros de URL',
      filtrosTexto: 'Para rastrear solo una parte del sitio. Las exclusiones ganan sobre el filtro de inclusión.'
    },
    site: {
      indice: 'En esta página',
      resumo: 'Resumen',
      tecnico: 'Técnico',
      recorte: 'Valen para Técnico y Páginas. Las otras pestañas muestran la ejecución completa.',
      criticos: 'Incidencias críticas',
      avisos: 'Avisos',
      cargaMedia: 'Media de {ms} ms en las {n} páginas rastreadas.',
      links: {
        titulo: 'Enlaces rotos',
        com: 'Páginas con enlace roto',
        proprios: 'Con enlace propio roto',
        template:
          'Ninguna página tiene enlace propio roto: es el mismo enlace del diseño, repetido en todas. Corregir la plantilla resuelve las {n}.',
        proprio: 'Para saber qué páginas tienen enlace propio roto, use la columna "Enlaces rotos (propios)" en Páginas.'
      },
      carga: 'Respuesta del HTML (ms)',
      dasPaginas: '{pct}% de las páginas',
      paginas: { um: '{n} página', outros: '{n} páginas' },
      aviso: 'aviso',
      profundidadeMax: 'profundidad máxima {n}',
      de: '{a} de {b}',
      problemas: { titulo: 'Problemas', nota: 'Gravedad primero, después cantidad. Al hacer clic se abre Páginas filtrada por el problema.', escala: 'barra = % de las {n} páginas' },
      cartao: { metadados: 'Metadatos', acesso: 'Accesibilidad y enlaces', profundidade: 'Clics desde la home', status: 'Estado HTTP' },
      paginasSub: 'El mismo recorte de Técnico. El CSV sale con los filtros, todas las columnas y los problemas de cada página.',
      problema: 'Problema',
      semProblema: 'Sin filtro'
    },
    run: {
      numeros: 'Números de la ejecución'
    },
    otim: {
      caminho: 'Optimizaciones',
      profundidade: 'Profundidad'
    },
    yt: {
      graficos: 'Gráficos',
      recorte: 'Valen para el resumen, los gráficos y la tabla. Rendimiento del canal muestra la ejecución completa.'
    }
  }
};

export default es;
